const letter3 = {
  id: 3,
  passage: `Subject: Concern Regarding Product Quality – Order #B67890

Dear Customer Support,

I recently received my order (ProTech Laptop Bag, Order #B67890) and was disappointed with the product's condition. Upon unboxing, I noticed that the zipper was defective, making it difficult to open and close the bag. Additionally, there were visible scratches on the surface, which suggests that the item was either used or mishandled before shipping.

As a loyal customer, I expect high-quality products and reliable service. I would like to request a replacement item or a partial refund as compensation for the defective product. Kindly advise me on how to proceed with this request.

I hope this matter can be resolved quickly. I appreciate your prompt attention.

Sincerely,
Emily Carter
+1-555-789-0123
emily.carter@email.com`,

  translation: `제목: 제품 품질 관련 우려사항 - 주문번호 #B67890

고객지원팀께,

최근 주문한 제품(ProTech 노트북 가방, 주문번호 #B67890)을 받았는데 제품 상태가 실망스러웠습니다. 포장을 풀어보니 지퍼에 결함이 있어 가방을 열고 닫기가 어려웠습니다. 또한 표면에 눈에 띄는 긁힘이 있어, 배송 전에 사용되었거나 잘못 취급된 것으로 보입니다.

충성 고객으로서 저는 고품질의 제품과 신뢰할 수 있는 서비스를 기대합니다. 불량 제품에 대한 보상으로 제품 교체나 부분 환불을 요청하고 싶습니다. 이 요청을 어떻게 진행해야 하는지 안내해 주시기 바랍니다.

이 문제가 신속히 해결되기를 바랍니다. 신속한 관심 부탁드립니다.

감사합니다.
`,

  koreanNouns: `Subject: Concern Regarding Product Quality – Order #B67890

Dear Customer Support,

I recently received my order (ProTech Laptop Bag, Order #B67890) and was disappointed with the product's condition. Upon unboxing, I noticed that the zipper was defective, making it difficult to open and close the bag. Additionally, there were visible scratches on the surface, which suggests that the item was either used or mishandled before shipping.

As a loyal customer, I expect high-quality products and reliable service. I would like to request a replacement item or a partial refund as compensation for the defective product. Kindly advise me on how to proceed with this request.

I hope this matter can be resolved quickly. I appreciate your prompt attention.

Sincerely,
Emily Carter
+1-555-789-0123
emily.carter@email.com`,

  wordPairs: {},

  questions: [],
};

const letter4 = {
  id: 4,
  passage: `Subject: New Employee Onboarding Policy

Dear Team,

Effective from March 1, we will be <mark>implementing</mark> a new onboarding policy for all newly hired employees. Under this policy, new employees will be required to complete a three-week training program before <mark>assuming</mark> their regular duties.

The training sessions will cover company policies, workplace safety, and department-specific procedures. Attendance is mandatory, and managers are expected to ensure that new hires complete the program. A detailed schedule and training materials will be distributed next week.

If you have any questions regarding this change, please contact HR at hr@company.com. We appreciate your cooperation in making this transition smooth.

Best regards,
James Peterson
Human Resources Manager`,

  translation: `제목: 신입 직원 온보딩 정책

팀원 여러분,

3월 1일부터 모든 신규 채용 직원들을 위한 새로운 온보딩 정책이 시행될 예정입니다. 이 정책에 따라, 신입 직원들은 정규 업무를 시작하기 전에 3주간의 교육 프로그램을 이수해야 합니다.

교육 세션은 회사 정책, 직장 안전, 그리고 부서별 절차를 다룰 예정입니다. 출석은 필수이며, 관리자들은 신입 직원들이 프로그램을 완료하도록 확인해야 합니다. 자세한 일정과 교육 자료는 다음 주에 배포될 예정입니다.

이 변경사항에 대해 질문이 있으시면 인사팀(hr@company.com)으로 문의해 주시기 바랍니다. 원활한 전환을 위한 여러분의 협조에 감사드립니다.

감사합니다.
James Peterson
인사 관리자`,
  koreanNouns: `Subject: New Employee Onboarding Policy

Dear Team,

Effective from March 1, we will be <mark>시행될</mark> a new onboarding policy for all newly hired employees. Under this policy, new employees will be required to complete a three-week training program before <mark>시작하기</mark> their regular duties.

The training sessions will cover company policies, workplace safety, and department-specific procedures. Attendance is mandatory, and managers are expected to ensure that new hires complete the program. A detailed schedule and training materials will be distributed next week.

If you have any questions regarding this change, please contact HR at hr@company.com. We appreciate your cooperation in making this transition smooth.

Best regards,
James Peterson
Human Resources Manager`,

  wordPairs: {
    implementing: "시행될",
    assuming: "시작하기",
  },

  questions: [],
};

const letter5 = {
  id: 5,
  passage: `From: Customer Support Team, Horizon Electronics
To: Mr. Daniel Lawson
Date: March 7, 2025
Subject: Refund Request for Order #HZE-24589

Dear Mr. Lawson,

We appreciate your patience regarding your recent refund request for Order #HZE-24589. After carefully reviewing your case, we regret to hear that the product did not meet your expectations, and we sincerely apologize for any inconvenience this may have caused.

As per our return and refund policy, refunds are processed for items that are returned in their original condition within 30 days of purchase. Our records indicate that your request was submitted beyond the <mark>stipulated</mark> timeframe. However, as a valued customer, we are pleased to offer you an exceptional one-time refund as a gesture of goodwill.

To proceed with the refund, please ensure that the item is <mark>securely</mark> packaged and shipped to our return center using the prepaid shipping label provided in the attachment. Once we receive and inspect the item, your refund will be processed within 7 to 10 business days <mark>via</mark> the original payment method.

If you require further clarification or assistance, please do not hesitate to reach out. We <mark>truly</mark> appreciate your business and look forward to serving you again in the future.

Best regards,
Customer Support Team
Horizon Electronics`,

  translation: `발신: 고객지원팀, Horizon Electronics
수신: Daniel Lawson 님
날짜: 2025년 3월 7일
제목: 주문번호 #HZE-24589에 대한 환불 요청

Lawson 님께,

주문번호 #HZE-24589에 대한 최근 환불 요청과 관련하여 기다려 주셔서 감사합니다. 귀하의 사례를 신중히 검토한 결과, 제품이 기대에 미치지 못했다는 점에 대해 유감스럽게 생각하며, 이로 인해 발생한 불편에 대해 진심으로 사과드립니다.

당사의 반품 및 환불 정책에 따르면, 환불은 구매일로부터 30일 이내에 원래 상태로 반품된 물품에 대해 처리됩니다. 당사의 기록에 따르면 귀하의 요청은 규정된 기간을 초과하여 제출되었습니다. 그러나 소중한 고객님께 선의의 표시로 이번 한 번에 한하여 특별 환불을 제공해 드리게 되어 기쁘게 생각합니다.

환불을 진행하시려면, 첨부된 선불 배송 라벨을 사용하여 물품을 안전하게 포장하여 당사의 반품 센터로 발송해 주시기 바랍니다. 물품을 수령하고 검수한 후, 7-10 영업일 이내에 원래의 결제 방식으로 환불이 처리될 예정입니다.

추가 설명이나 도움이 필요하시면 언제든 문의해 주시기 바랍니다. 귀하의 거래에 진심으로 감사드리며, 향후에도 계속해서 서비스를 제공해 드릴 수 있기를 기대합니다.

감사합니다.
고객지원팀
Horizon Electronics`,
  koreanNouns: `From: Customer Support Team, Horizon Electronics
To: Mr. Daniel Lawson
Date: March 7, 2025
Subject: Refund Request for Order #HZE-24589

Dear Mr. Lawson,

We appreciate your patience regarding your recent refund request for Order #HZE-24589. After carefully reviewing your case, we regret to hear that the product did not meet your expectations, and we sincerely apologize for any inconvenience this may have caused.

As per our return and refund policy, refunds are processed for items that are returned in their original condition within 30 days of purchase. Our records indicate that your request was submitted beyond the <mark>규정된</mark> timeframe. However, as a valued customer, we are pleased to offer you an exceptional one-time refund as a gesture of goodwill.

To proceed with the refund, please ensure that the item is <mark>안전하게</mark> packaged and shipped to our return center using the prepaid shipping label provided in the attachment. Once we receive and inspect the item, your refund will be processed within 7 to 10 business days <mark>통해</mark> the original payment method.

If you require further clarification or assistance, please do not hesitate to reach out. We <mark>진심으로</mark> appreciate your business and look forward to serving you again in the future.

Best regards,
Customer Support Team
Horizon Electronics`,

  wordPairs: {
    stipulated: "규정된",
    securely: "안전하게",
    via: "통해",
    truly: "진심으로",
  },

  questions: [],
};

const letter6 = {
  id: 6,
  passage: `Subject: Request for Assistance with Marketing Campaign

Dear Mr. Thompson,

I hope you are doing well. We are currently preparing a new marketing campaign for the upcoming product <mark>launch</mark> and would greatly appreciate your team's expertise in designing promotional materials.

Specifically we require assistance with:

Creating digital advertisements for online platforms
Designing brochures and print materials for distribution
Would you be available for a <mark>brief</mark> call next week to discuss the project details? Please let me know your availability, and I will arrange a meeting at your convenience.

Your support would be <mark>invaluable</mark> to the success of this campaign. I look forward to your response.

Best regards,
Sophia Mitchell
Marketing Manager`,

  translation: `제목: 마케팅 캠페인 지원 요청

Thompson님께,

안녕하십니까. 저희는 현재 새로운 제품 출시를 위한 마케팅 캠페인을 준비 중이며, 홍보 자료 디자인에 대한 귀 팀의 전문성을 지원받고자 합니다.

구체적으로, 다음 사항들에 대한 지원이 필요합니다:

온라인 플랫폼용 디지털 광고 제작
배포용 브로셔 및 인쇄물 디자인
다음 주에 프로젝트 세부사항을 논의하기 위한 간단한 통화가 가능하신가요? 가능하신 시간을 알려주시면 편하신 때로 회의를 조정하도록 하겠습니다.

귀하의 지원은 이 캠페인의 성공에 매우 중요할 것입니다. 답변을 기다리겠습니다.

감사합니다.
[Sophia Mitchell]
마케팅 매니저`,

  koreanNouns: `Subject: Request for Assistance with Marketing Campaign

Dear Mr. Thompson,

I hope you are doing well. We are currently preparing a new marketing campaign for the upcoming product <mark>출시</mark> and would greatly appreciate your team's expertise in designing promotional materials.

Specifically we require assistance with:

Creating digital advertisements for online platforms
Designing brochures and print materials for distribution
Would you be available for a <mark>짧은</mark> call next week to discuss the project details? Please let me know your availability, and I will arrange a meeting at your convenience.

Your support would be <mark>매우 중요한</mark> to the success of this campaign. I look forward to your response.

Best regards,
Sophia Mitchell
Marketing Manager`,
  wordPairs: {
    brief: "짧은",
    invaluable: "매우 중요한",
    launch: "출시",
  },

  questions: [],
};

const letter7 = {
  id: 7,
  passage: `Subject: New Account Approval

Dear Mr. Jonathan Reed,

We are pleased to inform you that your new account application has been successfully processed and approved. Your account is now active and ready for use. Please find the key details below:

Account Details:

Account Number: 2356-8745-9123
Account Type: Savings Account
Opening Date: March 7, 2025

To ensure a <mark>seamless</mark> banking experience, we encourage you to activate your online banking by following these steps:

Visit our official website at www.horizonbank.com
Click on "Register for Online Banking"
Enter your account number and verify your identity
Set up your login <mark>credentials</mark> and security questions

For security reasons, we advise you to change your temporary PIN immediately and avoid sharing your credentials with anyone. If you have requested a debit card or checkbook, they will be <mark>dispatched</mark> within 5-7 business days.

Should you have any questions or require assistance, please do not hesitate to contact our customer service team at support@horizonbank.com or call us at +1 (800) 555-0199.

We appreciate your trust in Horizon Bank and look forward to serving you.

Best regards,
Michael Patterson
Customer Support Team
Horizon Bank`,

  translation: `제목: 신규 계좌 승인

Jonathan Reed 님께,

귀하의 신규 계좌 신청이 성공적으로 처리되어 승인되었음을 알려드립니다. 귀하의 계좌는 현재 활성화되어 사용 가능한 상태입니다. 주요 세부사항은 아래와 같습니다:

계좌 정보:

계좌번호: 2356-8745-9123
계좌 유형: 예금 계좌
개설일: 2025년 3월 7일

원활한 은행 서비스 이용을 위해 다음 단계에 따라 온라인 뱅킹을 활성화하시기를 권장드립니다:

공식 웹사이트 www.horizonbank.com 방문
"온라인 뱅킹 등록" 클릭
계좌번호 입력 및 본인 인증
로그인 정보 및 보안 질문 설정

보안을 위해 임시 PIN을 즉시 변경하시고 계좌 정보를 타인과 공유하지 않으시기를 권고드립니다. 체크카드나 수표책을 신청하신 경우, 영업일 기준 5-7일 내에 발송될 예정입니다.

문의사항이나 도움이 필요하신 경우, support@horizonbank.com으로 이메일을 보내시거나 +1 (800) 555-0199로 고객 서비스 팀에 연락 주시기 바랍니다.

Horizon Bank를 신뢰해 주셔서 감사드리며, 귀하를 모실 수 있기를 기대합니다.

감사합니다.
Michael Patterson
고객 지원팀
Horizon Bank`,

  koreanNouns: `Subject: New Account Approval

Dear Mr. Jonathan Reed,

We are pleased to inform you that your new account application has been successfully processed and approved. Your account is now active and ready for use. Please find the key details below:

Account Details:

Account Number: 2356-8745-9123
Account Type: Savings Account
Opening Date: March 7, 2025

To ensure a <mark>원활한</mark> banking experience, we encourage you to activate your online banking by following these steps:

Visit our official website at www.horizonbank.com
Click on "Register for Online Banking"
Enter your account number and verify your identity
Set up your login <mark>자격정보</mark> and security questions

For security reasons, we advise you to change your temporary PIN immediately and avoid sharing your credentials with anyone. If you have requested a debit card or checkbook, they will be <mark>발송될</mark> within 5-7 business days.

Should you have any questions or require assistance, please do not hesitate to contact our customer service team at support@horizonbank.com or call us at +1 (800) 555-0199.

We appreciate your trust in Horizon Bank and look forward to serving you.

Best regards,
Michael Patterson
Customer Support Team
Horizon Bank`,

  wordPairs: {
    seamless: "원활한",
    credentials: "자격정보",
    dispatched: "발송될",
  },

  questions: [],
};

const letter8 = {
  id: 8,
  passage: `Subject: Initial Deposit Confirmation

Dear Ms. Emily Park,

We are pleased to confirm that your initial deposit of $2,500 has been successfully credited to your newly opened Horizon Bank Savings Account. Below are the transaction details for your reference:

Transaction Summary:

<mark>Account Holder</mark>: Emily Park
<mark>Account Number</mark>: 6789-1234-5678
<mark>Deposit Amount</mark>: $2,500.00
Transaction Date: March 7, 2025
Deposit Method: <mark>Direct Transfer</mark> from External Bank

Please note that a minimum balance of $500 is required to maintain your account in active status. If your balance falls below this <mark>threshold</mark>, a monthly service fee of $15 will be <mark>deducted</mark>.

Additionally, your account is eligible for an annual interest rate of 1.8%, which will be calculated on a <mark>compound</mark> <mark>quarterly</mark> basis. To maximize your savings, we recommend setting up an automatic direct deposit or enrolling in our fixed-term deposit options for higher interest rates.

You may access your account balance, <mark>transaction</mark> history, and e-statements at any time through Horizon Bank Online Banking. If you have not yet activated your online banking profile, please visit www.horizonbank.com and complete the registration process.

For any inquiries regarding your deposit or account features, please contact our Customer Service Team at support@horizonbank.com or call us at +1 (800) 555-0199.

We appreciate your trust in Horizon Bank and look forward to serving you.

Best regards,
Daniel Roberts
Customer Support Manager
Horizon Bank`,

  translation: `제목: 초기 입금 확인

Emily Park 고객님께,

고객님의 신규 개설된 Horizon Bank 저축 계좌에 초기 입금액 $2,500이 성공적으로 입금되었음을 확인해 드립니다. 아래는 참고하실 거래 내역입니다:

거래 내역:

계좌 소유주: Emily Park
계좌 번호: 6789-1234-5678
입금액: $2,500.00
거래일: 2025년 3월 7일
입금 방법: 외부 은행에서 직접 이체

계좌를 활성 상태로 유지하기 위해서는 최소 잔액 $500이 필요합니다. 잔액이 이 기준 미만으로 떨어질 경우, 월 서비스 수수료 $15가 차감됩니다.

또한, 고객님의 계좌는 연 이율 1.8%를 적용받으며, 이는 분기별로 복리 계산됩니다. 저축을 최대화하기 위해 자동 직접 입금을 설정하시거나 더 높은 이율을 제공하는 정기 예금 상품에 가입하시는 것을 추천드립니다.

Horizon Bank 온라인 뱅킹을 통해 언제든지 계좌 잔액, 거래 내역, 전자명세서를 확인하실 수 있습니다. 아직 온라인 뱅킹 프로필을 활성화하지 않으셨다면, www.horizonbank.com을 방문하여 등록 절차를 완료해 주시기 바랍니다.

입금이나 계좌 기능에 대해 문의사항이 있으시면 고객 서비스팀(이메일: support@horizonbank.com, 전화: +1 (800) 555-0199)으로 연락 주시기 바랍니다.

Horizon Bank를 신뢰해 주셔서 감사드리며, 앞으로도 최선을 다해 서비스하겠습니다.

감사합니다.
Daniel Roberts
고객 지원 매니저
Horizon Bank`,

  koreanNouns: `Subject: Initial Deposit Confirmation

Dear Ms. Emily Park,

We are pleased to confirm that your initial deposit of $2,500 has been successfully credited to your newly opened Horizon Bank Savings Account. Below are the transaction details for your reference:

Transaction Summary:

<mark>계좌 소유주</mark>: Emily Park
<mark>계좌 번호</mark>: 6789-1234-5678
<mark>입금액</mark>: $2,500.00
Transaction Date: March 7, 2025
Deposit Method: <mark>직접 이체</mark> from External Bank

Please note that a minimum balance of $500 is required to maintain your account in active status. If your balance falls below this <mark>기준</mark>, a monthly service fee of $15 will be <mark>차감됩니다</mark>.

Additionally, your account is eligible for an annual interest rate of 1.8%, which will be calculated on a <mark>복리</mark> <mark>분기별로</mark> basis. To maximize your savings, we recommend setting up an automatic direct deposit or enrolling in our fixed-term deposit options for higher interest rates.

You may access your account balance, <mark>거래 내역</mark> history, and e-statements at any time through Horizon Bank Online Banking. If you have not yet activated your online banking profile, please visit www.horizonbank.com and complete the registration process.

For any inquiries regarding your deposit or account features, please contact our Customer Service Team at support@horizonbank.com or call us at +1 (800) 555-0199.

We appreciate your trust in Horizon Bank and look forward to serving you.

Best regards,
Daniel Roberts
Customer Support Manager
Horizon Bank`,

  wordPairs: {
    "Account Holder": "계좌 소유주",
    "Account Number": "계좌 번호",
    "Deposit Amount": "입금액",
    "Direct Transfer": "직접 이체",
    transaction: "거래 내역",
    threshold: "기준",
    deducted: "차감됩니다",
    compound: "복리",
    quarterly: "분기별로",
  },

  questions: [],
};

const letter9 = {
  id: 9,
  passage: `Subject: Office Closure for Public Holiday

Dear Employees,

Please be informed that our office will be closed on Monday, May 27, in observance of Memorial Day. Regular operations will resume on Tuesday, May 28.

Employees who are required to work on this day due to project deadlines should coordinate with their respective supervisors. If you have any urgent matters, please ensure they are addressed in advance.

We appreciate your hard work and hope you enjoy the holiday.

Best regards,
[Sarah Johnson]
Operations Manager`,

  translation: `제목: 공휴일 사무실 휴무 안내

직원 여러분,

5월 27일 월요일 현충일로 인해 사무실이 휴무임을 알려드립니다. 정상 업무는 5월 28일 화요일에 재개됩니다.

프로젝트 마감일로 인해 이날 근무해야 하는 직원들은 각자의 관리자와 조율하시기 바랍니다. 긴급한 사안이 있는 경우 미리 처리해 주시기 바랍니다.

여러분의 노고에 감사드리며, 즐거운 휴일 보내시기 바랍니다.

감사합니다.
[Sarah Johnson]
운영 관리자`,

  koreanNouns: `Subject: Office Closure for Public Holiday
  
Dear Employees,

Please be informed that our office will be closed on Monday, May 27, <mark>기념하여</mark> <mark>현충일</mark>. <mark>정상 업무</mark> will <mark>재개</mark> on Tuesday, May 28.

Employees  who are required to work on this day due to project deadlines should <mark>조율</mark> with their <mark>각자의</mark> supervisors. If you have any urgent matters, please ensure they are <mark>처리</mark> in advance.

We appreciate your hard work and hope you enjoy the holiday.

Best regards,
[Sarah Johnson]
Operations Manager`,

  wordPairs: {
    기념하여: "in observance of",
    현충일: "Memorial Day",
    "정상 업무": "regular operations",
    재개: "resume",

    조율: "coordinate",
    각자의: "respective",
    처리: "addressed",
  },

  questions: [],
};

const letter10 = {
  id: 10,
  passage: `Subject: Mandatory Workplace Safety Training

Dear Employees,

As part of our ongoing <mark>commitment</mark> to workplace safety, all employees are required to complete a mandatory safety training session. The training will be held as follows:

Date: Friday, April 5
Time: 10:00 AM – 12:00 PM
Location: Main Conference Hall
Attendance is <mark>compulsory</mark> for all staff members. Employees who are unable to attend must notify HR in advance and complete the training online.

If you have any questions, please contact training@company.com.

Best regards,
Jennifer Adams
Training Coordinator`,

  translation: `제목: 필수 직장 안전 교육

직원 여러분,

직장 안전에 대한 지속적인 노력의 일환으로, 모든 직원들은 필수 안전 교육 세션을 이수해야 합니다. 교육은 다음과 같이 진행됩니다:

날짜: 4월 5일 금요일
시간: 오전 10시 - 오후 12시
장소: 메인 컨퍼런스홀
모든 직원의 참석이 의무입니다. 참석이 불가능한 직원들은 인사팀에 사전 통보하고 온라인으로 교육을 이수해야 합니다.

문의사항이 있으시면 training@company.com으로 연락 주시기 바랍니다.

감사합니다.
Jennifer Adams
교육 코디네이터`,

  koreanNouns: `Subject: Mandatory Workplace Safety Training

Dear Employees,

As part of our ongoing <mark>노력</mark> to workplace safety, all employees are required to complete a mandatory safety training session. The training will be held as follows:

Date: Friday, April 5
Time: 10:00 AM – 12:00 PM
Location: Main Conference Hall
Attendance is <mark>의무</mark> for all staff members. Employees who are unable to attend must notify HR in advance and complete the training online.

If you have any questions, please contact training@company.com.

Best regards,
Jennifer Adams
Training Coordinator`,

  wordPairs: {
    commitment: "노력",
    compulsory: "의무",
  },

  questions: [],
};

const letter11 = {
  id: 11,
  passage: `Subject: Appreciation for Outstanding Customer Support

Dear Customer Service Team,

I am writing to express my sincere appreciation for the excellent support I received from your team regarding my recent order (Order #D45678). Your representative, Mr. Andrew Carter, was extremely professional and efficient in resolving my issue.

Despite my request being <mark>somewhat</mark> complicated, Mr. Carter handled it with patience and <mark>expertise</mark>. Thanks to his <mark>prompt</mark> assistance, my concern was addressed within 24 hours, exceeding my expectations.

I truly appreciate the <mark>dedication</mark> and professionalism of your customer service team. I will continue to be a loyal customer and will not hesitate to recommend your company to others.

Sincerely,
Olivia Patterson
+1-555-321-6789
olivia.patterson@email.com`,

  translation: `제목: 뛰어난 고객 지원에 대한 감사

고객 서비스팀 귀중,

최근 주문(주문번호 #D45678)과 관련하여 귀 팀으로부터 받은 훌륭한 지원에 대해 진심으로 감사드립니다. 귀사의 담당자인 Andrew Carter씨는 제 문제를 해결하는데 있어 매우 전문적이고 효율적이었습니다.

제 요청이 다소 복잡했음에도 불구하고, Carter씨는 인내심과 전문성을 가지고 처리해 주셨습니다. 그의 신속한 지원 덕분에 제 문제가 24시간 이내에 해결되어 기대 이상이었습니다.

귀사의 고객 서비스팀의 헌신과 전문성에 깊이 감사드립니다. 저는 계속해서 충성 고객이 될 것이며, 다른 분들에게도 귀사를 추천하는 것을 주저하지 않을 것입니다.

감사합니다.
`,
  koreanNouns: `Subject: Appreciation for Outstanding Customer Support

Dear Customer Service Team,

I am writing to express my sincere appreciation for the excellent support I received from your team regarding my recent order (Order #D45678). Your representative, Mr. Andrew Carter, was extremely professional and efficient in resolving my issue.

Despite my request being <mark>다소</mark> complicated, Mr. Carter handled it with patience and <mark>전문성</mark>. Thanks to his <mark>신속한</mark> assistance, my concern was addressed within 24 hours, exceeding my expectations.

I truly appreciate the <mark>헌신</mark> and professionalism of your customer service team. I will continue to be a loyal customer and will not hesitate to recommend your company to others.

Sincerely,
Olivia Patterson
+1-555-321-6789
olivia.patterson@email.com`,

  wordPairs: {
    somewhat: "다소",
    expertise: "전문성",
    prompt: "신속한",
    dedication: "헌신",
  },

  questions: [],
};

const letter12 = {
  id: 12,
  passage: `Subject: Thank You for Your Hard Work and Dedication

Dear Team,

I would like to take this opportunity to <mark>extend</mark> my gratitude for your hard work and dedication over the past quarter. Your <mark>commitment</mark> to excellence has significantly contributed to our company's success.

In particular, I would like to recognize the sales and marketing departments for their <mark>outstanding</mark> efforts in exceeding our quarterly targets. Your determination and teamwork have not gone <mark>unnoticed</mark>, and I truly appreciate your contributions.

Thank you once again for your dedication. I look forward to achieving even greater success together in the coming months.

Best regards,
Jonathan Mitchell
Chief Executive Officer`,

  translation: `제목: 열심히 일해주시고 헌신해 주셔서 감사합니다

팀원 여러분,

지난 분기 동안 보여주신 여러분의 노고와 헌신에 감사드리고자 합니다. 여러분의 탁월함에 대한 헌신이 우리 회사의 성공에 크게 기여했습니다.

특히 분기별 목표를 초과 달성한 영업부와 마케팅부의 뛰어난 노력을 인정하고 싶습니다. 여러분의 결단력과 팀워크는 주목받았으며, 여러분의 기여에 진심으로 감사드립니다.

다시 한 번 여러분의 헌신에 감사드립니다. 앞으로 몇 달 동안 함께 더 큰 성공을 이루기를 기대합니다.

감사합니다.
Jonathan Mitchell
최고경영자`,

  koreanNouns: `Subject: Thank You for Your Hard Work and Dedication

Dear Team,

I would like to take this opportunity to <mark>전하다</mark> my gratitude for your hard work and dedication over the past quarter. Your <mark>헌신</mark> to excellence has significantly contributed to our company's success.

In particular, I would like to recognize the sales and marketing departments for their <mark>뛰어난</mark> efforts in exceeding our quarterly targets. Your determination and teamwork have not gone <mark>주목받지 않은</mark>, and I truly appreciate your contributions.

Thank you once again for your dedication. I look forward to achieving even greater success together in the coming months.

Best regards,
Jonathan Mitchell
Chief Executive Officer`,

  wordPairs: {
    extend: "전하다",
    commitment: "헌신",
    outstanding: "뛰어난",
    unnoticed: "주목받지 않은",
  },

  questions: [],
};

const letter13 = {
  id: 13,
  passage: `Subject: Appreciation for Your Valuable Partnership

Dear Mr. Richardson,

On behalf of our entire team, I would like to express our sincere appreciation for your continued partnership and support. Over the past year, your company has played a <mark>crucial</mark> role in helping us deliver high-quality products and services to our clients.

Your professionalism, <mark>reliability</mark>, and commitment to excellence have been truly <mark>commendable</mark>. We value this partnership and look forward to continued collaboration in the future.

Once again, thank you for your dedication and outstanding service. We look forward to many more successful projects together.

Best regards,
Michael Harris
Director of Operations`,

  translation: `제목: 귀중한 파트너십에 대한 감사

Richardson님께,

저희 전체 팀을 대표하여, 지속적인 파트너십과 지원에 대해 진심으로 감사드립니다. 지난 한 해 동안, 귀사는 저희가 고객들에게 고품질의 제품과 서비스를 제공하는 데 중요한 역할을 해주셨습니다.

귀사의 전문성, 신뢰성, 그리고 탁월함에 대한 헌신은 정말 칭찬할 만합니다. 저희는 이 파트너십을 소중히 여기며, 앞으로도 지속적인 협력을 기대합니다.

다시 한 번 귀사의 헌신과 뛰어난 서비스에 감사드립니다. 앞으로도 더 많은 성공적인 프로젝트를 함께 하기를 기대합니다.

감사합니다.
Michael Harris
운영 이사`,

  koreanNouns: `Subject: Appreciation for Your Valuable Partnership

Dear Mr. Richardson,

On behalf of our entire team, I would like to express our sincere appreciation for your continued partnership and support. Over the past year, your company has played a <mark>중요한</mark> role in helping us deliver high-quality products and services to our clients.

Your professionalism, <mark>신뢰성</mark>, and commitment to excellence have been truly <mark>칭찬할 만한</mark>. We value this partnership and look forward to continued collaboration in the future.

Once again, thank you for your dedication and outstanding service. We look forward to many more successful projects together.

Best regards,
Michael Harris
Director of Operations`,

  wordPairs: {
    crucial: "중요한",
    reliability: "신뢰성",
    commendable: "칭찬할 만한",
  },

  questions: [],
};

const letter14 = {
  id: 14,
  passage: `Subject: Request to Reschedule Project Review Meeting

Dear Mr. Anderson,

I hope this email finds you well. I am writing to inform you that we need to reschedule the Project Review Meeting originally set for Tuesday, March 12, at 3:00 PM due to an unexpected scheduling conflict.

Would you be available on Thursday, March 14, at 2:00 PM instead? If this time does not work for you, please let me know your availability, and I will adjust the schedule <mark>accordingly</mark>.

I apologize for any inconvenience this may cause and appreciate your <mark>flexibility</mark>. Please confirm the <mark>revised</mark> meeting schedule at your earliest convenience.

Best regards,
James Carter
Project Coordinator`,

  translation: `제목: 프로젝트 검토 회의 일정 변경 요청

Anderson님께,

안녕하십니까. 예기치 않은 일정 충돌로 인해 3월 12일 화요일 오후 3시로 예정되어 있던 프로젝트 검토 회의 일정을 변경해야 함을 알려드립니다.

대신 3월 14일 목요일 오후 2시에 가능하신지요? 만약 이 시간이 적절하지 않으시다면, 가능하신 시간을 알려주시면 그에 따라 일정을 조정하도록 하겠습니다.

불편을 끼쳐 죄송합니다. 양해해 주셔서 감사합니다. 변경된 회의 일정을 가능한 한 빨리 확인해 주시기 바랍니다.

감사합니다.
James Carter
프로젝트 코디네이터`,

  koreanNouns: `Subject: Request to Reschedule Project Review Meeting

Dear Mr. Anderson,

I hope this email finds you well. I am writing to inform you that we need to reschedule the Project Review Meeting originally set for Tuesday, March 12, at 3:00 PM due to an unexpected scheduling conflict.

Would you be available on Thursday, March 14, at 2:00 PM instead? If this time does not work for you, please let me know your availability, and I will adjust the schedule <mark>accordingly</mark>.

I apologize for any inconvenience this may cause and appreciate your <mark>flexibility</mark>. Please confirm the <mark>revised</mark> meeting schedule at your earliest convenience.

Best regards,
James Carter
Project Coordinator`,

  wordPairs: {
    accordingly: "그에 따라",
    flexibility: "양해",
    revised: "변경된",
  },

  questions: [],
};

const letter15 = {
  id: 15,
  passage: `Subject: Inquiry Regarding Service Agreement Terms

Dear Ms. Robertson,

I am reaching out to seek <mark>clarification</mark> regarding the terms <mark>outlined</mark> in the service agreement we received on March 5. Before proceeding with the contract, we would like to confirm a few details related to the payment schedule and service <mark>deliverables</mark>.

Could you please provide additional information on the following points?

The exact <mark>billing cycle</mark> and any applicable late fees.
The process for requesting modifications to <mark>service scope</mark> after the contract is signed.
We appreciate your assistance in this matter. Please let us know if we need to arrange a call to discuss these details further.

Looking forward to your response.

Best regards,
Daniel Foster
Procurement Manager`,

  translation: `제목: 서비스 계약 조건에 관한 문의

Robertson님께,

3월 5일에 받은 서비스 계약서에 명시된 조건들에 대해 명확히 하고자 연락드립니다. 계약을 진행하기 전에, 지불 일정과 서비스 제공 사항과 관련된 몇 가지 세부사항을 확인하고 싶습니다.

다음 사항들에 대해 추가 정보를 제공해 주시겠습니까?

정확한 청구 주기와 해당되는 연체료
계약 체결 후 서비스 범위 수정 요청 절차
이 건에 대한 귀하의 도움에 감사드립니다. 이러한 세부사항들을 더 논의하기 위해 통화 일정을 잡을 필요가 있다면 알려주시기 바랍니다.

답변을 기다리겠습니다.

감사합니다.
Daniel Foster
구매 관리자`,

  koreanNouns: `Subject: Inquiry Regarding Service Agreement Terms

Dear Ms. Robertson,

I am reaching out to seek <mark>설명</mark> regarding the terms <mark>명시된</mark> in the service agreement we received on March 5. Before proceeding with the contract, we would like to confirm a few details related to the payment schedule and service <mark>납품물</mark>.

Could you please provide additional information on the following points?

The exact <mark>청구 주기</mark> and any applicable late fees.
The process for requesting modifications to <mark>서비스 범위</mark> after the contract is signed.
We appreciate your assistance in this matter. Please let us know if we need to arrange a call to discuss these details further.

Looking forward to your response.

Best regards,
Daniel Foster
Procurement Manager`,

  wordPairs: {
    clarification: "설명",
    outlined: "명시된",
    deliverables: "납품물",
    "billing cycle": "청구 주기",
    "service scope": "서비스 범위",
  },

  questions: [],
};

const letter16 = {
  id: 16,
  passage: `Subject: Notice of Overdraft - Account #4589-1023-6789

Dear Mr. Andrew Kim,

We are writing to inform you that your <mark>checking account</mark> (Account Number: 4589-1023-6789) has exceeded the available balance, resulting in an <mark>overdraft</mark>. As of March 7, 2025, a <mark>transaction</mark> attempted on your account caused a negative balance of -$75.30.

Transaction Details:
Transaction Date: March 6, 2025
Merchant: Greenfield Supermarket
Transaction Amount: $120.50
Available Balance Before Transaction: $45.20
Overdraft Amount: -$75.30
Overdraft Fee Charged: $35.00

As per Horizon Bank's <mark>overdraft</mark> policy, an <mark>overdraft</mark> fee of $35.00 has been applied to your account. To avoid additional charges, we <mark>strongly</mark> recommend depositing sufficient funds to bring your account back to a positive balance by March 10, 2025.

To prevent future <mark>overdraft</mark> fees, you may consider:
- Setting up <mark>overdraft</mark> protection by linking your <mark>checking account</mark> to a <mark>savings account</mark>.
- Enabling low-balance <mark>alerts</mark> through Horizon Bank Online Banking.
- Reviewing your monthly <mark>expenses</mark> and setting up an automatic direct deposit.

You may check your account balance or make a deposit through online banking, mobile banking, or any Horizon Bank branch. If you have any questions or need assistance, please contact our Customer Service Team at support@horizonbank.com or call us at +1 (800) 555-0199.

Thank you for your prompt attention to this matter.

Best regards,
Rachel Stevens
Customer Support Manager
Horizon Bank`,

  translation: `제목: 당좌대월 통지 - 계좌번호 #4589-1023-6789

김앤드류 고객님께,

고객님의 당좌예금 계좌(계좌번호: 4589-1023-6789)가 사용 가능한 잔액을 초과하여 당좌대월이 발생하였음을 알려드립니다. 2025년 3월 7일 기준, 계좌에서 시도된 거래로 인해 -$75.30의 마이너스 잔액이 발생했습니다.

거래 내역:
거래일: 2025년 3월 6일
가맹점: 그린필드 슈퍼마켓
거래금액: $120.50
거래 전 사용 가능 잔액: $45.20
당좌대월 금액: -$75.30
당좌대월 수수료: $35.00

호라이즌 은행의 당좌대월 정책에 따라 $35.00의 당좌대월 수수료가 계좌에 청구되었습니다. 추가 수수료 발생을 방지하기 위해 2025년 3월 10일까지 계좌 잔액을 양수로 만들기에 충분한 금액을 입금하실 것을 강력히 권고드립니다.

향후 당좌대월 수수료 방지를 위해 다음 사항을 고려해보시기 바랍니다:
- 당좌예금 계좌를 저축예금 계좌와 연결하여 당좌대월 보호 설정하기
- 호라이즌 은행 온라인 뱅킹을 통해 잔액 부족 알림 설정하기
- 월간 지출을 검토하고 자동 급여이체 설정하기

계좌 잔액 확인이나 입금은 온라인 뱅킹, 모바일 뱅킹 또는 호라이즌 은행 지점을 통해 가능합니다. 문의사항이나 도움이 필요하신 경우 고객서비스팀(이메일: support@horizonbank.com, 전화: +1 (800) 555-0199)으로 연락 주시기 바랍니다.

신속한 조치 부탁드립니다.

감사합니다.
레이첼 스티븐스
고객지원 매니저
호라이즌 은행`,

  koreanNouns: `Subject: Notice of <mark>초과인출</mark> - Account #4589-1023-6789

Dear Mr. Andrew Kim,

We are writing to inform you that your <mark>예금 계좌</mark> (Account Number: 4589-1023-6789) has exceeded the available balance, resulting in an <mark>초과인출</mark>. As of March 7, 2025, a <mark>거래</mark> attempted on your account caused a negative balance of -$75.30.

<mark>거래</mark> Details:
<mark>거래</mark> Date: March 6, 2025
<mark>가맹점</mark>: Greenfield Supermarket
<mark>거래</mark> Amount: $120.50
Available Balance Before <mark>거래</mark>: $45.20
<mark>초과인출</mark> Amount: -$75.30
<mark>초과인출</mark> Fee Charged: $35.00

As per Horizon Bank's <mark>초과인출</mark> policy, an <mark>초과인출</mark> fee of $35.00 has been applied to your account. To avoid additional charges, we <mark>강력히</mark> recommend depositing sufficient funds to bring your account back to a positive balance by March 10, 2025.

To prevent future <mark>초과인출</mark> fees, you may consider:
- Setting up <mark>초과인출</mark> protection by linking your <mark>예금 계좌</mark> to a <mark>저축예금 계좌</mark>.
- Enabling low-balance <mark>알림</mark> through Horizon Bank Online Banking.
- Reviewing your monthly <mark>지출</mark> and setting up an automatic direct deposit.

You may check your account balance or make a deposit through online banking, mobile banking, or any Horizon Bank branch. If you have any questions or need assistance, please contact our Customer Service Team at support@horizonbank.com or call us at +1 (800) 555-0199.

Thank you for your prompt attention to this matter.

Best regards,
Rachel Stevens
Customer Support Manager
Horizon Bank`,

  wordPairs: {
    초과인출: "overdraft",
    "예금 계좌": "checking account",
    거래: "transaction",
    가맹점: "merchant",
    강력히: "strongly",
    "저축예금 계좌": "savings account",
    알림: "alert",
    지출: "expenses",
  },

  questions: [],
};
const letter17 = {
  id: 7,
  passage: `Subject: Interview Invitation - Marketing Associate Position

Dear Ms. Olivia Chen,

We are pleased to inform you that your <mark>application</mark> for the Marketing Associate position at Horizon Solutions has been <mark>shortlisted</mark>. After a thorough review of your qualifications and experience, we would like to invite you to an interview as part of our selection process.

Interview Details:
- Date: March 12, 2025
- Time: 10:00 AM – 11:00 AM
- Location: Horizon Solutions Headquarters, 5th Floor, 123 Greenway Avenue, New York, NY
- Format: In-person (Virtual option available upon request)

During the interview, you will meet with the Hiring Manager and Senior Marketing Team, and we will discuss your qualifications, professional experience, and suitability for the role. Additionally, you may be asked to complete a brief skills assessment relevant to the position.

Please confirm your availability for the scheduled interview by replying to this email no later than March 8, 2025. If you require any adjustments or <mark>accommodations</mark>, do not hesitate to inform us in advance.

We appreciate your interest in joining Horizon Solutions, and we look forward to speaking with you soon.

Best regards,
Daniel Roberts
HR Coordinator
Horizon Solutions`,

  translation: `제목: 면접 초대 - 마케팅 담당자 직책

올리비아 첸 님께,

호라이즌 솔루션즈의 마케팅 담당자 직책에 지원해 주셔서 감사합니다. 귀하의 자격과 경력을 면밀히 검토한 결과, 채용 과정의 일환으로 면접에 초대하고자 합니다.

면접 세부사항:
날짜: 2025년 3월 12일
시간: 오전 10:00 – 오전 11:00
장소: 호라이즌 솔루션즈 본사, 5층, 123 그린웨이 애비뉴, 뉴욕, 뉴욕 주
형식: 대면 면접 (요청 시 화상 면접 가능)

면접에서는 채용 담당자와 시니어 마케팅 팀을 만나 귀하의 자격, 직무 경험, 그리고 해당 직책에 대한 적합성을 논의할 예정입니다. 또한 직무와 관련된 간단한 실무 평가가 있을 수 있습니다.

2025년 3월 8일까지 이메일로 면접 일정 참석 가능 여부를 알려주시기 바랍니다. 특별한 조정이나 편의가 필요하신 경우 미리 알려주시기 바랍니다.

호라이즌 솔루션즈에 관심을 가져주셔서 감사드리며, 곧 만나 뵙기를 기대합니다.

감사합니다.
대니얼 로버츠
인사 코디네이터
호라이즌 솔루션즈`,
  koreanNouns: `Subject: Interview Invitation - Marketing Associate Position

Dear Ms. Olivia Chen,

We are pleased to inform you that your <mark>지원서</mark> for the Marketing Associate position at Horizon Solutions has been <mark>서류 합격된</mark>. After a thorough review of your qualifications and experience, we would like to invite you to an interview as part of our selection process.

Interview Details:
- Date: March 12, 2025
- Time: 10:00 AM – 11:00 AM
- Location: Horizon Solutions Headquarters, 5th Floor, 123 Greenway Avenue, New York, NY
- Format: In-person (Virtual option available upon request)

During the interview, you will meet with the Hiring Manager and Senior Marketing Team, and we will discuss your qualifications, professional experience, and suitability for the role. Additionally, you may be asked to complete a brief skills assessment relevant to the position.

Please confirm your availability for the scheduled interview by replying to this email no later than March 8, 2025. If you require any adjustments or <mark>편의 시설</mark>, do not hesitate to inform us in advance.

We appreciate your interest in joining Horizon Solutions, and we look forward to speaking with you soon.

Best regards,
Daniel Roberts
HR Coordinator
Horizon Solutions`,

  wordPairs: {
    application: "지원서",
    shortlisted: "서류 합격된",
    accommodations: "편의 시설",
  },
  questions: [],
};
const letter18 = {
  id: 18,
  passage: `Subject: Job Opening – Marketing Coordinator Position

Dear Team,

We are excited to announce that Horizon Solutions is currently seeking a Marketing Coordinator to join our dynamic team. This is an excellent opportunity for a <mark>highly</mark> motivated individual with a passion for brand management, digital marketing, and market research.

Position Details:
- Job Title: Marketing Coordinator
- Location: Horizon Solutions <mark>Headquarters</mark>, New York, NY
- Employment Type: <mark>Full-time</mark>
- Salary: Competitive, based on experience
- Application Deadline: March 20, 2025

Key Responsibilities:
Develop and <mark>execute</mark> marketing campaigns to enhance brand visibility.
Conduct market research and analyze consumer trends.
Collaborate with cross-functional teams to create promotional materials.
Manage the company's social media presence and digital advertising efforts.
Monitor and report on campaign performance metrics.

Qualifications & Requirements:
✔ <mark>Bachelor's degree</mark> in Marketing, Business Administration, or a related field.
✔ Minimum of 2 years of experience in marketing or advertising.
✔ <mark>Proficiency</mark> in digital marketing tools and analytics platforms.
✔ Strong communication and organizational skills.
✔ Ability to work in a <mark>fast-paced</mark> environment and meet deadlines.

How to Apply:
Interested candidates are encouraged to submit their resume and cover letter to hr@horizoncompany.com by March 20, 2025. Shortlisted applicants will be contacted for further interviews.

For any questions regarding this position, please reach out to Daniel Roberts (HR Director) at hr@horizoncompany.com.

We look forward to welcoming a <mark>talented</mark> new team member to Horizon Solutions!

Best regards,
Daniel Roberts
HR Director
Horizon Solutions`,

  translation: `제목: 채용 공고 - 마케팅 코디네이터 직책

팀원 여러분께,

호라이즌 솔루션즈에서 역동적인 팀에 합류할 마케팅 코디네이터를 모집하고 있음을 기쁘게 알려드립니다. 이는 브랜드 관리, 디지털 마케팅, 시장 조사에 열정을 가진 의욕 넘치는 인재에게 좋은 기회가 될 것입니다.

직책 세부사항:
- 직책명: 마케팅 코디네이터
- 근무지: 호라이즌 솔루션즈 본사, 뉴욕, 뉴욕 주
- 고용형태: 정규직
- 급여: 경력에 따른 경쟁력 있는 급여
- 지원마감: 2025년 3월 20일

주요 업무:
브랜드 가시성 향상을 위한 마케팅 캠페인 개발 및 실행
시장 조사 및 소비자 트렌드 분석
홍보 자료 제작을 위한 부서 간 협업
회사 소셜 미디어 관리 및 디지털 광고 활동
캠페인 성과 지표 모니터링 및 보고

자격요건 및 필수사항:
✔ 마케팅, 경영학 또는 관련 분야 학사 학위
✔ 마케팅 또는 광고 분야 2년 이상 경력
✔ 디지털 마케팅 도구 및 분석 플랫폼 능숙도
✔ 뛰어난 의사소통 및 조직력
✔ 빠른 업무 환경에서 일하며 기한 준수 능력

지원 방법:
관심 있는 지원자는 2025년 3월 20일까지 이력서와 자기소개서를 hr@horizoncompany.com으로 제출해 주시기 바랍니다. 선발된 지원자에 한해 추가 면접을 진행할 예정입니다.

해당 직책에 대한 문의사항은 대니얼 로버츠(인사 디렉터)에게 hr@horizoncompany.com으로 연락 주시기 바랍니다.

호라이즌 솔루션즈에서 재능 있는 새 팀원을 맞이하기를 기대합니다!

감사합니다.
대니얼 로버츠
인사 디렉터
호라이즌 솔루션즈`,

  koreanNouns: `Subject: Job Opening – Marketing Coordinator Position

Dear Team,

We are excited to announce that Horizon Solutions is currently seeking a Marketing Coordinator to join our dynamic team. This is an excellent opportunity for a <mark>매우</mark> motivated individual with a passion for brand management, digital marketing, and market research.

Position Details:
- Job Title: Marketing Coordinator
- Location: Horizon Solutions <mark>본사</mark>, New York, NY
- Employment Type: <mark>정규직</mark>
- Salary: Competitive, based on experience
- Application Deadline: March 20, 2025

Key Responsibilities:
Develop and <mark>실행하다</mark> marketing campaigns to enhance brand visibility.
Conduct market research and analyze consumer trends.
Collaborate with cross-functional teams to create promotional materials.
Manage the company's social media presence and digital advertising efforts.
Monitor and report on campaign performance metrics.

Qualifications & Requirements:
✔ <mark>학사 학위</mark> in Marketing, Business Administration, or a related field.
✔ Minimum of 2 years of experience in marketing or advertising.
✔ <mark>능숙도</mark> in digital marketing tools and analytics platforms.
✔ Strong communication and organizational skills.
✔ Ability to work in a <mark>빠른 업무 환경</mark> environment and meet deadlines.

How to Apply:
Interested candidates are encouraged to submit their resume and cover letter to hr@horizoncompany.com by March 20, 2025. Shortlisted applicants will be contacted for further interviews.

For any questions regarding this position, please reach out to Daniel Roberts (HR Director) at hr@horizoncompany.com.

We look forward to welcoming a <mark>재능 있는</mark> new team member to Horizon Solutions!

Best regards,
Daniel Roberts
HR Director
Horizon Solutions`,

  wordPairs: {
    highly: "매우",
    "Full-time": "정규직",
    Headquarters: "본사",
    execute: "실행하다",
    "Bachelor's degree": "학사 학위",
    Proficiency: "능숙도",
    "fast-paced": "빠른 업무 환경",
    talented: "재능 있는",
  },

  questions: [],
};

const letter19 = {
  id: 9,
  passage: `Subject: Application Status – Marketing Coordinator Position

Dear Mr. Benjamin Lee,

We appreciate your interest in the Marketing Coordinator position at Horizon Solutions and the time you invested in the <mark>recruitment process</mark>. After careful consideration of all <mark>applicants</mark>, we regret to inform you that we have decided to move forward with another <mark>candidate</mark> whose <mark>qualifications</mark> more closely <mark>align</mark> with the requirements of the role.

This decision was not made <mark>lightly</mark>, as we received applications from many highly qualified <mark>professionals</mark>. While your <mark>skills</mark> and experience are <mark>commendable</mark>, we had to make a selection based on specific business <mark>needs</mark> and team composition.

We encourage you to <mark>keep an eye on</mark> future <mark>career opportunities</mark> at Horizon Solutions, as your background and <mark>expertise</mark> may be a great fit for another role. We invite you to visit our <mark>careers page</mark> <mark>regularly</mark> at www.horizoncompany.com/careers for upcoming <mark>openings</mark>.

Thank you again for your time and effort <mark>throughout</mark> the application process. We <mark>sincerely</mark> appreciate your interest in our company and wish you the best in your career <mark>endeavors</mark>.

Best regards,
Daniel Roberts
HR Director
Horizon Solutions`,

  translation: `제목: 지원 결과 안내 - 마케팅 코디네이터 직책

벤자민 리 님께,

호라이즌 솔루션즈의 마케팅 코디네이터 직책에 관심을 가지고 채용 과정에 시간을 투자해 주셔서 감사합니다. 모든 지원자를 신중히 검토한 결과, 해당 직책의 요구사항에 더 적합한 다른 후보자를 선발하게 되었음을 안타깝게 알려드립니다.

많은 우수한 전문가들의 지원서를 받았기에 이번 결정은 신중하게 이루어졌습니다. 귀하의 능력과 경험이 훌륭함에도 불구하고, 저희는 특정 업무 요구사항과 팀 구성을 고려하여 선발을 진행해야 했습니다.

귀하의 배경과 전문성이 다른 직책에 적합할 수 있으므로, 호라이즌 솔루션즈의 향후 채용 기회에 관심을 가져주시기 바랍니다. www.horizoncompany.com/careers에서 새로운 채용 공고를 정기적으로 확인해 주시기 바랍니다.

지원 과정에서 보여주신 시간과 노력에 다시 한번 감사드립니다. 저희 회사에 관심을 가져주셔서 진심으로 감사드리며, 귀하의 앞날에 행운이 함께하기를 기원합니다.

감사합니다.
대니얼 로버츠
인사 디렉터
호라이즌 솔루션즈`,
  koreanNouns: `Subject: Application Status – Marketing Coordinator Position

Dear Mr. Benjamin Lee,

We appreciate your interest in the Marketing Coordinator position at Horizon Solutions and the time you invested in the <mark>채용 과정</mark>. After careful consideration of all <mark>지원자</mark>, we regret to inform you that we have decided to move forward with another <mark>후보자</mark> whose <mark>자격요건</mark> more closely <mark>부합하는</mark> with the requirements of the role.

This decision was not made <mark>가볍게</mark>, as we received applications from many highly qualified <mark>전문가</mark>. While your <mark>능력</mark> and experience are <mark>훌륭한</mark>, we had to make a selection based on specific business <mark>요구사항</mark> and team composition.

We encourage you to <mark>주시하다</mark> future <mark>채용 기회</mark> at Horizon Solutions, as your background and <mark>전문성</mark> may be a great fit for another role. We invite you to visit our <mark>채용 페이지</mark> <mark>정기적으로</mark> at www.horizoncompany.com/careers for upcoming <mark>공고</mark>.

Thank you again for your time and effort <mark>전반에 걸쳐</mark> the application process. We <mark>진심으로</mark> appreciate your interest in our company and wish you the best in your career <mark>발전</mark>.

Best regards,
Daniel Roberts
HR Director
Horizon Solutions`,

  wordPairs: {
    "채용 과정": "recruitment process",
    지원자: "applicants",
    후보자: "candidate",
    자격요건: "qualifications",
    부합하는: "align",
    가볍게: "lightly",
    전문가: "professionals",
    능력: "skills",
    요구사항: "needs",
    주시하다: "keep an eye on",
    "채용 기회": "career opportunities",
    전문성: "expertise",
    "채용 페이지": "careers page",
    정기적으로: "regularly",
    공고: "openings",
    "전반에 걸쳐": "throughout",
    진심으로: "sincerely",
    훌륭한: "commendable",
    발전: "endeavors",
  },

  questions: [],
};

const letter20 = {
  id: 20,
  passage: `Subject: Job Offer & Onboarding Information – Marketing Coordinator Position

Dear Ms. Rachel Kim,

We are pleased to offer you the position of Marketing Coordinator at Horizon Solutions. After a <mark>thorough</mark> evaluation of your qualifications and interview performance, we are confident that your skills and experience will be a <mark>valuable</mark> addition to our team.

Offer Details:
- Position: Marketing Coordinator
- Location: Horizon Solutions Headquarters, New York, NY
- Employment Type: Full-time
- Salary: $60,000 per year
- Start Date: April 1, 2025

This offer is contingent upon the successful completion of the required pre-employment procedures, including a background check and submission of necessary employment documents.

Next Steps – <mark>Onboarding Process</mark>:
To facilitate a smooth transition, please review and complete the following steps:
✔ Sign and return the offer letter by March 10, 2025.
✔ Submit employment documents (proof of identity, tax forms, and direct deposit information).
✔ Attend the New Hire Orientation scheduled for April 2, 2025, where you will receive details on company policies, benefits, and your initial training schedule.

If you have any questions regarding the terms of employment, benefits, or onboarding procedures, please do not hesitate to contact HR@horizoncompany.com.

We are excited to welcome you to Horizon Solutions and look forward to your contributions!

Best regards,
Daniel Roberts
HR Director
Horizon Solutions`,

  translation: `제목: 채용 제안 및 입사 안내 - 마케팅 코디네이터 직책

레이첼 김 님께,

호라이즌 솔루션즈의 마케팅 코디네이터 직책을 제안드리게 되어 기쁩니다. 귀하의 자격요건과 면접 수행 능력을 철저히 평가한 결과, 귀하의 능력과 경험이 우리 팀에 가치 있는 자산이 될 것이라 확신합니다.

채용 상세 내용:
- 직책: 마케팅 코디네이터
- 근무지: 호라이즌 솔루션즈 본사, 뉴욕
- 고용 형태: 정규직
- 연봉: $60,000
- 입사일: 2025년 4월 1일

이 채용 제안은 신원 조회와 필요한 고용 서류 제출을 포함한 채용 전 필수 절차의 성공적인 완료를 전제로 합니다.

다음 단계 - 입사 절차:
원활한 전환을 위해 다음 단계를 검토하고 완료해 주시기 바랍니다:
✔ 2025년 3월 10일까지 채용 제안서 서명 및 회신
✔ 고용 서류 제출 (신분증, 세금 양식, 계좌이체 정보)
✔ 2025년 4월 2일 예정된 신입 사원 오리엔테이션 참석 (회사 정책, 복리후생, 초기 교육 일정에 대한 상세 내용 안내 예정)

고용 조건, 복리후생 또는 입사 절차에 대해 문의사항이 있으시면 언제든 HR@horizoncompany.com으로 연락 주시기 바랍니다.

호라이즌 솔루션즈에 오신 것을 환영하며, 귀하의 기여를 기대합니다!

감사합니다.
대니얼 로버츠
인사 디렉터
호라이즌 솔루션즈`,

  koreanNouns: `Subject: Job Offer & Onboarding Information – Marketing Coordinator Position

Dear Ms. Rachel Kim,

We are pleased to offer you the position of Marketing Coordinator at Horizon Solutions. After a <mark>철저한</mark> evaluation of your qualifications and interview performance, we are confident that your skills and experience will be a <mark>가치 있는</mark> addition to our team.

Offer Details:
- Position: Marketing Coordinator
- Location: Horizon Solutions Headquarters, New York, NY
- Employment Type: Full-time
- Salary: $60,000 per year
- Start Date: April 1, 2025

This offer is contingent upon the successful completion of the required pre-employment procedures, including a background check and submission of necessary employment documents.

Next Steps – <mark>입사 절차</mark>:
To facilitate a smooth transition, please review and complete the following steps:
✔ Sign and return the offer letter by March 10, 2025.
✔ Submit employment documents (proof of identity, tax forms, and direct deposit information).
✔ Attend the New Hire Orientation scheduled for April 2, 2025, where you will receive details on company policies, benefits, and your initial training schedule.

If you have any questions regarding the terms of employment, benefits, or onboarding procedures, please do not hesitate to contact HR@horizoncompany.com.

We are excited to welcome you to Horizon Solutions and look forward to your contributions!

Best regards,
Daniel Roberts
HR Director
Horizon Solutions`,

  wordPairs: {
    thorough: "철저한",
    valuable: "가치 있는",
    "Onboarding Process": "입사 절차",
  },

  questions: [],
};
const letter21 = {
  id: 21,
  passage: `Subject: Important Information Regarding Your Severance Pay & Retirement Plan

Dear Mr. Thomas Bennett,

We would like to provide you with detailed information regarding your <mark>severance package</mark> and retirement plan options as you prepare for your departure from Horizon Solutions. We appreciate your dedicated service and wish to ensure a smooth transition into the next phase of your career.

Severance Pay Details:
- <mark>Eligibility</mark>: Employees with a tenure of three years or more
- Severance Payment: Based on years of service and final salary
- Payout Schedule: <mark>Lump sum</mark> payment will be processed within 30 days of your final working day
- Tax Implications: Severance pay may <mark>be subject to</mark> income tax deductions <mark>in accordance with</mark> federal and state regulations

If you have any questions regarding the calculation of your severance package, please reach out to HR@horizoncompany.com.

Retirement Plan Options:
As a <mark>departing</mark> employee, you have several options regarding your 401(k) retirement plan:
✔ Rollover to an IRA or another employer-sponsored plan to maintain tax-deferred status
✔ Withdraw funds, which may be subject to early withdrawal penalties and income tax
✔ Leave your account with Horizon Solutions if the balance exceeds the required minimum

To initiate any changes to your retirement savings account, please contact our Financial Benefits Team at benefits@horizoncompany.com no later than April 15, 2025.

Next Steps:
You will receive a final <mark>paycheck</mark>, including any accrued but unused paid time off (PTO).
Your health insurance coverage will remain active through the end of the month, after which you may be eligible for COBRA continuation coverage.
You may schedule a one-on-one consultation with an HR representative to discuss your severance and retirement options in detail.

We thank you for your contributions to Horizon Solutions and wish you success in your future endeavors. If you need further assistance, do not hesitate to contact us.

Best regards,
Daniel Roberts
HR Director
Horizon Solutions`,

  translation: `제목: 퇴직금 및 퇴직연금 관련 중요 안내

토마스 베넷 님께,

호라이즌 솔루션즈에서의 퇴사를 준비하시는 과정에서 퇴직금 패키지와 퇴직연금 플랜 옵션에 대한 상세 정보를 안내해 드리고자 합니다. 그동안의 헌신적인 근무에 감사드리며, 새로운 경력으로의 원활한 전환을 지원하고자 합니다.

퇴직금 상세 내용:
- 자격 요건: 3년 이상 근속 직원
- 퇴직금: 근속 연수와 최종 급여를 기준으로 산정
- 지급 일정: 최종 근무일로부터 30일 이내 일시불 지급
- 세금 관련: 연방 및 주 규정에 따라 소득세가 공제될 수 있음

퇴직금 산정에 대해 문의사항이 있으시면 HR@horizoncompany.com으로 연락 주시기 바랍니다.

퇴직연금 플랜 옵션:
퇴사 직원으로서 401(k) 퇴직연금에 대해 다음과 같은 옵션이 있습니다:
✔ 세금 이연 상태를 유지하기 위해 IRA 또는 다른 고용주 후원 플랜으로 이전
✔ 자금 인출 (조기 인출 시 패널티 및 소득세 부과 가능)
✔ 잔액이 최소 요구 금액을 초과할 경우 호라이즌 솔루션즈에 계좌 유지

퇴직연금 계좌 변경을 원하시면 2025년 4월 15일까지 benefits@horizoncompany.com의 재무혜택팀으로 연락 주시기 바랍니다.

다음 단계:
미사용 유급휴가를 포함한 최종 급여를 지급받으실 예정입니다.
건강보험은 이번 달 말까지 유지되며, 이후 COBRA 연장 보험 가입 자격이 주어질 수 있습니다.
퇴직금과 퇴직연금 옵션에 대해 자세히 논의하기 위한 인사 담당자와의 1:1 상담을 예약하실 수 있습니다.

호라이즌 솔루션즈에 기여해 주신 점에 감사드리며, 앞으로의 발전을 기원합니다. 추가 도움이 필요하시면 언제든 연락 주시기 바랍니다.

감사합니다.
대니얼 로버츠
인사 디렉터
호라이즌 솔루션즈`,

  koreanNouns: `Subject: Important Information Regarding Your Severance Pay & Retirement Plan

Dear Mr. Thomas Bennett,

We would like to provide you with detailed information regarding your <mark>퇴직금 패키지</mark> and retirement plan options as you prepare for your departure from Horizon Solutions. We appreciate your dedicated service and wish to ensure a smooth transition into the next phase of your career.

Severance Pay Details:
- <mark>자격 요건</mark>: Employees with a tenure of three years or more
- Severance Payment: Based on years of service and final salary
- Payout Schedule: <mark>일시불</mark> payment will be processed within 30 days of your final working day
- Tax Implications: Severance pay may <mark>~의 대상이 되다</mark> income tax deductions <mark>에 따라</mark> federal and state regulations

If you have any questions regarding the calculation of your severance package, please reach out to HR@horizoncompany.com.

Retirement Plan Options:
As a <mark>떠나는</mark> employee, you have several options regarding your 401(k) retirement plan:
✔ Rollover to an IRA or another employer-sponsored plan to maintain tax-deferred status
✔ Withdraw funds, which may be subject to early withdrawal penalties and income tax
✔ Leave your account with Horizon Solutions if the balance exceeds the required minimum

To initiate any changes to your retirement savings account, please contact our Financial Benefits Team at benefits@horizoncompany.com no later than April 15, 2025.

Next Steps:
You will receive a final <mark>급여</mark>, including any accrued but unused paid time off (PTO).
Your health insurance coverage will remain active through the end of the month, after which you may be eligible for COBRA continuation coverage.
You may schedule a one-on-one consultation with an HR representative to discuss your severance and retirement options in detail.

We thank you for your contributions to Horizon Solutions and wish you success in your future endeavors. If you need further assistance, do not hesitate to contact us.

Best regards,
Daniel Roberts
HR Director
Horizon Solutions`,

  wordPairs: {
    "severance package": "퇴직금 패키지",
    Eligibility: "자격 요건",
    "Lump sum": "일시불",
    "in accordance with": "에 따라",
    departing: "떠나는",
    "be subject to": "~의 대상이 되다",
    paycheck: "급여",
  },

  questions: [],
};

const letter22 = {
  id: 22,
  passage: `Subject: Important Update: Changes to Vacation & Leave Policy
Dear Team,

We would like to inform you of upcoming modifications to our Vacation & Leave Policy, effective April 1, 2025. These changes are designed to provide greater flexibility while ensuring smooth workforce management across all departments. Please review the key updates below.

Key Policy Updates

📌 Annual Leave Entitlement:

Employees with less than three years of service: 12 days of paid annual leave (previously 10 days).
Employees with three or more years of service: 15 days of paid annual leave (previously 12 days).

📌 Carryover Policy:
Unused vacation days may now be carried over to the following year, up to a maximum of five days.
Any unused days beyond this limit will expire at the end of the calendar year.

📌 Request & Approval Process:
All leave requests must be submitted via the HR portal at least two weeks in advance.
Leave approval <mark>is subject to</mark> business needs and team availability.
Emergency leave requests will be handled on a case-by-case basis.

📌 Sick Leave & Personal Days:
Employees are entitled to five additional paid sick days per year.
Personal leave requests must be discussed with direct supervisors prior to submission.
To ensure compliance with the updated policy, we encourage all employees to review the full Vacation & Leave Policy document available on the company's intranet portal. If you have any questions or require further clarification, please contact HR@horizoncompany.com.

We appreciate your cooperation in implementing these changes and thank you for your continued dedication to the company.

Best regards,
Daniel Roberts
HR Director
Horizon Solutions`,

  translation: `제목: 휴가 및 휴직 정책 변경에 관한 중요 안내
팀원 여러분께,

2025년 4월 1일부터 시행될 휴가 및 휴직 정책의 변경 사항을 안내해 드립니다. 이번 변경은 모든 부서의 원활한 인력 관리를 보장하면서 더 큰 유연성을 제공하기 위해 마련되었습니다. 아래의 주요 변경 사항을 검토해 주시기 바랍니다.

주요 정책 변경 사항

📌 연차 휴가 자격:
근속 3년 미만 직원: 12일의 유급 연차 휴가 (기존 10일)
근속 3년 이상 직원: 15일의 유급 연차 휴가 (기존 12일)

📌 이월 정책:
미사용 휴가일은 최대 5일까지 다음 연도로 이월 가능
이 한도를 초과하는 미사용 일수는 해당 연도 말에 소멸

📌 신청 및 승인 절차:
모든 휴가 신청은 최소 2주 전에 HR 포털을 통해 제출
휴가 승인은 업무상 필요와 팀 가용성에 따라 결정
긴급 휴가 신청은 개별 상황에 따라 처리

📌 병가 및 개인 휴가:
직원들은 연간 5일의 추가 유급 병가 사용 가능
개인 휴가 신청은 제출 전 직속 상사와 논의 필요
변경된 정책의 준수를 위해 모든 직원들은 회사 인트라넷 포털에서 제공되는 전체 휴가 및 휴직 정책 문서를 검토하시기 바랍니다. 문의사항이나 추가 설명이 필요하신 경우 HR@horizoncompany.com으로 연락 주시기 바랍니다.

이러한 변경 사항 시행에 협조해 주심에 감사드리며, 회사에 대한 지속적인 헌신에 감사드립니다.

감사합니다.
대니얼 로버츠
인사 디렉터
호라이즌 솔루션즈`,
  koreanNouns: `Subject: Important Update: Changes to Vacation & Leave Policy
Dear Team,

We would like to inform you of upcoming modifications to our Vacation & Leave Policy, effective April 1, 2025. These changes are designed to provide greater flexibility while ensuring smooth workforce management across all departments. Please review the key updates below.

Key Policy Updates

📌 Annual Leave Entitlement:

Employees with less than three years of service: 12 days of paid annual leave (previously 10 days).
Employees with three or more years of service: 15 days of paid annual leave (previously 12 days).

📌 Carryover Policy:
Unused vacation days may now be carried over to the following year, up to a maximum of five days.
Any unused days beyond this limit will expire at the end of the calendar year.

📌 Request & Approval Process:
All leave requests must be submitted via the HR portal at least two weeks in advance.
Leave approval <mark>is subject to</mark> business needs and team availability.
Emergency leave requests will be handled on a case-by-case basis.

📌 Sick Leave & Personal Days:
Employees are entitled to five additional paid sick days per year.
Personal leave requests must be discussed with direct supervisors prior to submission.
To ensure compliance with the updated policy, we encourage all employees to review the full Vacation & Leave Policy document available on the company's intranet portal. If you have any questions or require further clarification, please contact HR@horizoncompany.com.

We appreciate your cooperation in implementing these changes and thank you for your continued dedication to the company.

Best regards,
Daniel Roberts
HR Director
Horizon Solutions`,

  wordPairs: {
    "is subject to": "~에 따라 결정됩니다",
  },

  questions: [],
};

const letter23 = {
  id: 23,
  passage: `Subject: Important Notice – Contract Renewal or Termination
Dear Mr. Jonathan Reed,

We are reaching out to inform you that your service contract with Horizon Solutions is set to expire on March 31, 2025. Please review the options below regarding your contract renewal or termination.

Renewal Option:
If you wish to continue your service without any interruption, please confirm your renewal by March 15, 2025. You may choose from the following renewal options:
✔ Automatic Renewal: Your contract will be extended for another 12 months under the current terms. No action is required.
✔ Manual Renewal: If you would like to make modifications to your contract, please contact our Client Services Team at contracts@horizoncompany.com before the deadline.

Termination Option:
If you decide not to renew your contract, kindly notify us in writing before March 15, 2025 to avoid any early termination fees. Please note:

If no action is taken, your contract may automatically renew under the existing terms.
A 30-day notice is required for voluntary contract termination.
Any outstanding balance must be settled before contract closure.
For further inquiries or to discuss your options, please reach out to your account manager or contact our customer support team at support@horizoncompany.com.

We appreciate your partnership with Horizon Solutions and look forward to continuing to serve you.

Best regards,
Daniel Roberts
Contract Management Team
Horizon Solutions`,

  translation: `제목: 중요 안내 - 계약 갱신 또는 해지
조나단 리드 님께,

호라이즌 솔루션즈와의 서비스 계약이 2025년 3월 31일에 만료될 예정임을 알려드립니다. 계약 갱신 또는 해지에 관한 아래의 옵션들을 검토해 주시기 바랍니다.

갱신 옵션:
서비스를 중단 없이 계속 이용하시려면 2025년 3월 15일까지 갱신 의사를 확인해 주시기 바랍니다. 다음의 갱신 옵션 중 선택하실 수 있습니다:
✔ 자동 갱신: 현재 조건으로 12개월 연장됩니다. 별도의 조치가 필요하지 않습니다.
✔ 수동 갱신: 계약 내용을 수정하시려면 마감일 전에 contracts@horizoncompany.com으로 고객 서비스팀에 연락해 주시기 바랍니다.

해지 옵션:
계약을 갱신하지 않기로 결정하신 경우, 조기 해지 수수료를 피하기 위해 2025년 3월 15일 이전에 서면으로 통보해 주시기 바랍니다. 다음 사항을 참고해 주십시오:

아무런 조치를 취하지 않으실 경우, 기존 조건으로 계약이 자동 갱신될 수 있습니다.
자발적 계약 해지 시 30일 전 통보가 필요합니다.
계약 종료 전 미결제 금액을 정산해야 합니다.
추가 문의사항이나 옵션 논의를 위해서는 담당 계정 관리자에게 연락하시거나 support@horizoncompany.com으로 고객 지원팀에 문의해 주시기 바랍니다.

호라이즌 솔루션즈와의 파트너십에 감사드리며, 앞으로도 계속해서 서비스를 제공해 드리기를 기대합니다.

감사합니다.
대니얼 로버츠
계약 관리팀
호라이즌 솔루션즈`,
  koreanNouns: `Subject: Important Notice – Contract Renewal or Termination
Dear Mr. Jonathan Reed,

We are <mark>연락드립니다</mark> to inform you that your service contract with Horizon Solutions is <mark>예정입니다</mark> expire on March 31, 2025. Please review the options below regarding your contract renewal or termination.

Renewal Option:
If you wish to continue your service without any <mark>중단</mark>, please confirm your renewal by March 15, 2025. You may choose from the <mark>다음</mark> renewal options:
✔ Automatic Renewal: Your contract will be <mark>연장</mark> for another 12 months under the current terms. <mark>조치가 필요하지 않습니다</mark>
✔ Manual Renewal: If you would like to make <mark>수정</mark> to your contract, please contact our Client Services Team at contracts@horizoncompany.com before the deadline.

Termination Option:
If you decide not to renew your contract, kindly notify us <mark>서면으로</mark> before March 15, 2025 to avoid any early termination fees. Please note:

<mark>아무런 조치를 취하지 않을 경우</mark>, your contract may automatically renew under the <mark>기존</mark> terms.
A 30-day <mark>통지</mark> is required for <mark>자발적 계약 해지</mark>.
Any <mark>미결제</mark> balance must be <mark>정산하다</mark> before contract closure.
For further inquiries or to discuss your options, please reach out to your account manager or contact our customer support team at support@horizoncompany.com.

We appreciate your partnership with Horizon Solutions and look forward to continuing to serve you.

Best regards,
Daniel Roberts
Contract Management Team
Horizon Solutions`,

  wordPairs: {
    연락드립니다: "are reaching out",
    예정입니다: "is set to",
    중단: "interruption",
    다음: "following",
    연장: "extended",
    "조치가 필요하지 않습니다": "no action is required",
    수정: "modifications",
    서면으로: "in writing",
    "아무런 조치를 취하지 않을 경우": "if no action is taken",
    기존: "existing",
    통지: "notice",
    "자발적 계약 해지": "voluntary contract termination",
    outstanding: "미결제",

    settled: "정산하다",
  },

  questions: [],
};

const letter24 = {
  id: 24,
  passage: `Subject: Invoice & Payment Request – Due by March 15, 2025
Dear Ms. Olivia Carter,

We are reaching out to remind you that Invoice #HZN-48231 is currently <mark>outstanding</mark> and requires payment by March 15, 2025. Below are the details of the invoice:

Invoice Summary
- Invoice Number: HZN-48231
- Invoice Date: March 1, 2025
- Total Amount Due: $3,250.00
- Due Date: March 15, 2025
- Payment Method: Bank Transfer / Credit Card

Payment Instructions
For your convenience, payment can be made via bank transfer using the details below:

Bank Name: Horizon Bank
Account Number: 123-456-789
SWIFT Code: HZNBUS33
Reference: Invoice #HZN-48231
Alternatively, you may process your payment <mark>securely</mark> through our online payment portal at www.horizoncompany.com/payments.

Late Payment Policy
If payment is not received by the due date, a late fee of 5% will be applied to the outstanding balance, and your account may <mark>be subject to</mark> temporary <mark>suspension</mark>. To avoid any disruption to your services, we kindly request that payment be made by the specified deadline.

Should you have any questions regarding this invoice or require an extension, please contact our Billing Department at billing@horizoncompany.com.

Thank you for your prompt attention to this matter.

Best regards,
Daniel Roberts
Accounts Receivable Team
Horizon Solutions`,

  translation: `제목: 청구서 및 지불 요청 - 2025년 3월 15일까지
올리비아 카터 님께,

청구서 #HZN-48231이 현재 미결제 상태이며 2025년 3월 15일까지 지불이 필요함을 상기시켜 드립니다. 아래는 청구서의 상세 내용입니다:

청구서 요약
- 청구서 번호: HZN-48231
- 청구일: 2025년 3월 1일
- 총 미결제 금액: $3,250.00
- 지불 기한: 2025년 3월 15일
- 지불 방법: 계좌이체 / 신용카드

지불 안내
편의를 위해 아래 정보를 사용하여 계좌이체로 지불하실 수 있습니다:

은행명: 호라이즌 은행
계좌번호: 123-456-789
SWIFT 코드: HZNBUS33
참조: 청구서 #HZN-48231
또는 www.horizoncompany.com/payments에서 온라인 결제 포털을 통해 안전하게 결제하실 수 있습니다.

연체 정책
기한까지 지불이 이루어지지 않을 경우, 미결제 잔액에 5%의 연체료가 부과되며, 계정이 일시적으로 정지될 수 있습니다. 서비스 중단을 피하기 위해 지정된 기한까지 지불해 주시기를 부탁드립니다.

이 청구서에 대해 문의사항이 있거나 기한 연장이 필요하신 경우, billing@horizoncompany.com으로 청구 부서에 연락해 주시기 바랍니다.

신속한 처리 부탁드립니다.

감사합니다.
대니얼 로버츠
미수금 관리팀
호라이즌 솔루션즈`,

  koreanNouns: `Subject: Invoice & Payment Request – Due by March 15, 2025
Dear Ms. Olivia Carter,

We are reaching out to remind you that Invoice #HZN-48231 is currently <mark>미결제된</mark> and requires payment by March 15, 2025. Below are the details of the invoice:

Invoice Summary
- Invoice Number: HZN-48231
- Invoice Date: March 1, 2025
- Total Amount Due: $3,250.00
- Due Date: March 15, 2025
- Payment Method: Bank Transfer / Credit Card

Payment Instructions
For your convenience, payment can be made via bank transfer using the details below:

Bank Name: Horizon Bank
Account Number: 123-456-789
SWIFT Code: HZNBUS33
Reference: Invoice #HZN-48231
Alternatively, you may process your payment <mark>안전하게</mark> through our online payment portal at www.horizoncompany.com/payments.

Late Payment Policy
If payment is not received by the due date, a late fee of 5% will be applied to the outstanding balance, and your account may <mark>~의 대상이 될 수 있습니다</mark> temporary <mark>정지</mark>. To avoid any disruption to your services, we kindly request that payment be made by the specified deadline.

Should you have any questions regarding this invoice or require an extension, please contact our Billing Department at billing@horizoncompany.com.

Thank you for your prompt attention to this matter.

Best regards,
Daniel Roberts
Accounts Receivable Team
Horizon Solutions`,

  wordPairs: {
    outstanding: "미결제된",
    securely: "안전하게",
    "be subject to": "~의 대상이 될 수 있습니다",
    suspension: "정지",
  },

  questions: [],
};

const letter25 = {
  id: 25,
  passage: `Subject: Invitation – Horizon Business Innovation Conference 2025
Dear Ms. Katherine Lee,

We are pleased to invite you to the Horizon Business Innovation Conference 2025, a premier event designed to bring together industry leaders, <mark>entrepreneurs</mark>, and professionals to explore the <mark>latest</mark> trends in business strategy, digital transformation, and leadership development.

Event Details:
✔ Date: April 25–26, 2025
✔ Location: Grand Summit Convention Center, San Francisco, CA
✔ Theme: "Innovate, Transform, Succeed – The Future of Business"


Keynote Speakers:
✔ Dr. Michael Roberts – CEO, Global Tech Solutions
✔ Ms. Emily Carter – <mark>Renowned</mark> Business Strategist & Author
✔ Mr. Jonathan Park – Chief Digital Officer, Horizon Innovations


Registration Information:
✔ Early Bird Discount: $250 (Register by March 31, 2025)
✔ Standard Registration Fee: $350 (After March 31, 2025)
✔ Group Discount: 10% off for groups of 5 or more

Register Now: Visit www.horizonconference2025.com to secure your spot.

Why Attend?
✔ Gain valuable insights from industry experts
✔ Participate in <mark>interactive</mark> workshops and panel discussions
✔ Expand your professional network with global business leaders

For any inquiries regarding the conference or registration, please contact our Event Coordinator, Lisa Adams, at events@horizoncompany.com.

We look forward to welcoming you to this exclusive event!

Best regards,
Daniel Roberts
Conference Director
Horizon Business Events`,

  translation: `제목: 초대장 - 2025 호라이즌 비즈니스 혁신 컨퍼런스
캐서린 리 님께,

산업 리더, 기업가 및 전문가들이 모여 비즈니스 전략, 디지털 전환, 리더십 개발의 최신 트렌드를 탐구하는 프리미어 이벤트인 2025 호라이즌 비즈니스 혁신 컨퍼런스에 귀하를 초대하게 되어 기쁩니다.

행사 세부사항:
✔ 일시: 2025년 4월 25일-26일
✔ 장소: 그랜드 서밋 컨벤션 센터, 샌프란시스코, CA
✔ 주제: "혁신, 변화, 성공 - 비즈니스의 미래"

기조연설자:
✔ 마이클 로버츠 박사 : 글로벌 테크 솔루션즈 CEO
✔ 에밀리 카터 : 저명한 비즈니스 전략가 및 작가
✔ 조나단 박 : 호라이즌 이노베이션즈 최고디지털책임자

등록 정보:
✔ 얼리버드 할인: $250 (2025년 3월 31일까지 등록)
✔ 일반 등록비: $350 (2025년 3월 31일 이후)
✔ 단체 할인: 5인 이상 그룹 10% 할인

 지금 등록하세요: www.horizonconference2025.com에서 자리를 확보하세요.

참석해야 하는 이유:
✔ 업계 전문가들로부터 귀중한 인사이트 획득
✔ 대화형 워크샵과 패널 토론 참여
✔ 글로벌 비즈니스 리더들과의 전문가 네트워크 확장

컨퍼런스나 등록에 관한 문의사항은 이벤트 코디네이터 리사 아담스(events@horizoncompany.com)에게 연락 주시기 바랍니다.

이 특별한 행사에서 귀하를 맞이하기를 기대합니다!

감사합니다.
대니얼 로버츠
컨퍼런스 디렉터
호라이즌 비즈니스 이벤츠`,

  koreanNouns: `Subject: Invitation – Horizon Business Innovation Conference 2025
Dear Ms. Katherine Lee,

We are pleased to invite you to the Horizon Business Innovation Conference 2025, a premier event designed to bring together industry leaders, <mark>기업가</mark>, and professionals to explore the <mark>최신</mark> trends in business strategy, digital transformation, and leadership development.

Event Details:
✔ Date: April 25–26, 2025
✔ Location: Grand Summit Convention Center, San Francisco, CA
✔ Theme: "Innovate, Transform, Succeed – The Future of Business"


Keynote Speakers:
✔ Dr. Michael Roberts – CEO, Global Tech Solutions
✔ Ms. Emily Carter – <mark>저명한</mark> Business Strategist & Author
✔ Mr. Jonathan Park – Chief Digital Officer, Horizon Innovations


Registration Information:
✔ Early Bird Discount: $250 (Register by March 31, 2025)
✔ Standard Registration Fee: $350 (After March 31, 2025)
✔ Group Discount: 10% off for groups of 5 or more

Register Now: Visit www.horizonconference2025.com to secure your spot.

Why Attend?
✔ Gain valuable insights from industry experts
✔ Participate in <mark>상호작용하는</mark> workshops and panel discussions
✔ Expand your professional network with global business leaders

For any inquiries regarding the conference or registration, please contact our Event Coordinator, Lisa Adams, at events@horizoncompany.com.

We look forward to welcoming you to this exclusive event!

Best regards,
Daniel Roberts
Conference Director
Horizon Business Events`,

  wordPairs: {
    entrepreneurs: "기업가",
    latest: "최신",
    Renowned: "저명한",
    interactive: "상호작용하는",
  },

  questions: [],
};

const letter26 = {
  id: 25,
  passage: `Subject: Important Update – Event Rescheduling Notice
Dear Attendees,

We regret to inform you that due to <mark>unforeseen</mark> circumstances, the Annual Business Innovation <mark>Summit</mark> 2025, originally scheduled for March 10, 2025, has been rescheduled to a later date. We sincerely apologize for any inconvenience this may cause and appreciate your understanding.

✔ Updated Event Details:
✔ New Date: April 15, 2025
✔ Time: 9:00 AM – 5:00 PM
✔ New Venue: Grand Summit Convention Center, New York, NY

Options for Registered Attendees:
1. Automatic Registration Transfer – If you are available on the new date, your registration will automatically be transferred at no additional cost. No further action is required.
2. Request for Refund – If you are unable to attend on the rescheduled date, you may request a full refund by contacting our support team at events@horizoncompany.com no later than March 25, 2025.

Additional Information:
If you have hotel reservations through our event partner, please contact them directly to modify your booking.
We will provide an updated <mark>agenda</mark> and speaker list closer to the event date.

If you have any further inquiries, feel free to reach out to our Event Coordination Team.

Once again, we appreciate your patience and hope to see you at the summit in April. Thank you for your continued support!

Best regards,
Daniel Roberts
Event Coordinator
Horizon Solutions`,

  translation: `제목: 중요 업데이트 - 행사 일정 변경 안내
참석자 여러분께,

예기치 않은 상황으로 인해 2025년 3월 10일로 예정되었던 연례 비즈니스 혁신 서밋이 추후 날짜로 변경되었음을 알려드립니다. 이로 인한 불편에 대해 진심으로 사과드리며 양해 부탁드립니다.

✔ 변경된 행사 세부사항:
✔ 새로운 날짜: 2025년 4월 15일
✔ 시간: 오전 9시 - 오후 5시
✔ 새로운 장소: 그랜드 서밋 컨벤션 센터, 뉴욕

등록된 참석자를 위한 옵션:
1. 자동 등록 이전 - 새로운 날짜에 참석 가능하신 경우, 추가 비용 없이 등록이 자동으로 이전됩니다. 추가 조치가 필요하지 않습니다.
2. 환불 요청 - 변경된 날짜에 참석이 불가능하신 경우, 2025년 3월 25일까지 events@horizoncompany.com으로 고객 지원팀에 연락하여 전액 환불을 요청하실 수 있습니다.

추가 정보:
행사 파트너사를 통해 호텔을 예약하신 경우, 직접 연락하여 예약을 변경해 주시기 바랍니다.
행사 날짜가 가까워지면 업데이트된 일정과 연사 명단을 제공해 드리겠습니다.

추가 문의사항이 있으시면 행사 조정팀에 연락해 주시기 바랍니다.
다시 한 번 양해해 주셔서 감사드리며, 4월에 서밋에서 뵙기를 희망합니다. 지속적인 지원에 감사드립니다!

감사합니다.
대니얼 로버츠
행사 조정자
호라이즌 솔루션즈`,

  koreanNouns: `Subject: Important Update – Event Rescheduling Notice
Dear Attendees,

We regret to inform you that due to <mark>예기치 않은</mark> circumstances, the Annual Business Innovation <mark>공식회의</mark> 2025, originally scheduled for March 10, 2025, has been rescheduled to a later date. We sincerely apologize for any inconvenience this may cause and appreciate your understanding.

✔ Updated Event Details:
✔ New Date: April 15, 2025
✔ Time: 9:00 AM – 5:00 PM
✔ New Venue: Grand Summit Convention Center, New York, NY

Options for Registered Attendees:
1. Automatic Registration Transfer – If you are available on the new date, your registration will automatically be transferred at no additional cost. No further action is required.
2. Request for Refund – If you are unable to attend on the rescheduled date, you may request a full refund by contacting our support team at events@horizoncompany.com no later than March 25, 2025.

Additional Information:
If you have hotel reservations through our event partner, please contact them directly to modify your booking.
We will provide an updated <mark>일정</mark> and speaker list closer to the event date.

If you have any further inquiries, feel free to reach out to our Event Coordination Team.

Once again, we appreciate your patience and hope to see you at the summit in April. Thank you for your continued support!

Best regards,
Daniel Roberts
Event Coordinator
Horizon Solutions`,

  wordPairs: {
    unforeseen: "예기치 않은",
    Summit: "공식회의",
    agenda: "일정",
  },

  questions: [],
};

const letter27 = {
  id: 27,
  passage: `Subject: Business Proposal – Strategic Partnership Opportunity
Dear Mr. David Richardson,

I hope this email finds you well. I am reaching out <mark>on behalf of</mark> Horizon Solutions to propose a strategic partnership that would create <mark>mutual</mark> growth opportunities for both our organizations.

📌 Proposal Overview:
We have identified a strong alignment between Horizon Solutions and GreenTech Enterprises, particularly in the area of <mark>sustainable</mark> technology development. Our proposed collaboration would focus on:
✔ Joint product development to enhance eco-friendly solutions in the market
✔ Knowledge sharing through specialized training sessions and industry workshops
✔ Co-marketing initiatives to expand brand visibility and customer engagement

📌 Key Benefits:
✔ Increased Market Reach: Leverage both companies' networks to attract a <mark>broader</mark> client base
✔ Cost Efficiency: Reduce R&D expenses through shared resources and expertise
✔ Competitive Advantage: Combine technological expertise to deliver innovative solutions

📌 Next Steps:
To further discuss this opportunity, we would like to schedule a virtual meeting at your convenience. Please let us know your availability for a 30-minute discussion next week.

If you require additional details, I am happy to provide a detailed business plan outlining the scope and potential impact of this collaboration.

We look forward to the possibility of working together and hope to establish a long-term partnership that benefits both organizations. Please feel free to reach out with any questions.

Best regards,
Daniel Roberts
Business Development Manager
Horizon Solutions
📧 daniel.roberts@horizoncompany.com`,

  translation: `제목: 사업 제안 - 전략적 파트너십 기회
데이비드 리처드슨 님께,

안녕하십니까. 양사의 상호 성장 기회를 창출할 전략적 파트너십을 제안하고자 호라이즌 솔루션즈를 대표하여 연락드립니다.

📌 제안 개요:
호라이즌 솔루션즈와 그린테크 엔터프라이즈 간에 특히 지속 가능한 기술 개발 분야에서 강력한 연계성을 확인했습니다. 제안된 협력은 다음 사항에 중점을 둘 것입니다:
✔ 시장의 친환경 솔루션을 강화하기 위한 공동 제품 개발
✔ 전문 교육 세션과 산업 워크샵을 통한 지식 공유
✔ 브랜드 가시성과 고객 참여를 확대하기 위한 공동 마케팅 이니셔티브

📌 주요 이점:
✔ 시장 도달 범위 확대: 양사의 네트워크를 활용하여 더 넓은 고객층 유치
✔ 비용 효율성: 공유 자원과 전문성을 통한 R&D 비용 절감
✔ 경쟁 우위: 기술적 전문성을 결합하여 혁신적인 솔루션 제공

📌 다음 단계:
이 기회를 더 논의하기 위해 귀하의 편의에 맞춰 화상 회의를 예약하고자 합니다. 다음 주 30분 논의를 위한 귀하의 가능한 시간을 알려주시기 바랍니다.

추가 세부사항이 필요하시다면 이 협력의 범위와 잠재적 영향을 설명하는 상세한 사업 계획서를 제공해 드리겠습니다.

함께 일할 수 있는 가능성을 기대하며, 양 조직에 도움이 되는 장기적인 파트너십을 구축하기를 희망합니다. 문의사항이 있으시면 언제든 연락 주시기 바랍니다.

감사합니다.
대니얼 로버츠
사업개발 매니저
호라이즌 솔루션즈
📧 daniel.roberts@horizoncompany.com`,
  koreanNouns: `Subject: Business Proposal – Strategic Partnership Opportunity
Dear Mr. David Richardson,

I hope this email finds you well. I am reaching out <mark>대표하여</mark> Horizon Solutions to propose a strategic partnership that would create <mark>상호적인</mark> growth opportunities for both our organizations.

📌 Proposal Overview:
We have identified a strong alignment between Horizon Solutions and GreenTech Enterprises, particularly in the area of <mark>지속 가능한</mark> technology development. Our proposed collaboration would focus on:
✔ Joint product development to enhance eco-friendly solutions in the market
✔ Knowledge sharing through specialized training sessions and industry workshops
✔ Co-marketing initiatives to expand brand visibility and customer engagement

📌 Key Benefits:
✔ Increased Market Reach: Leverage both companies' networks to attract a <mark>더 넓은</mark> client base
✔ Cost Efficiency: Reduce R&D expenses through shared resources and expertise
✔ Competitive Advantage: Combine technological expertise to deliver innovative solutions

📌 Next Steps:
To further discuss this opportunity, we would like to schedule a virtual meeting at your convenience. Please let us know your availability for a 30-minute discussion next week.

If you require additional details, I am happy to provide a detailed business plan outlining the scope and potential impact of this collaboration.

We look forward to the possibility of working together and hope to establish a long-term partnership that benefits both organizations. Please feel free to reach out with any questions.

Best regards,
Daniel Roberts
Business Development Manager
Horizon Solutions
📧 daniel.roberts@horizoncompany.com`,
  wordPairs: {
    "on behalf of": "대표하여",
    mutual: "상호적인",
    sustainable: "지속 가능한",
    broader: "더 넓은",
  },

  questions: [],
};
const letter28 = {
  id: 28,
  passage: `Subject: Request for Remote Work Equipment Support
  
Dear Sarah Peterson,

I hope you're doing well.

I am reaching out to inquire about the recently introduced Remote Work Equipment Support Program. As you know, working remotely has been incredibly beneficial, but I have found that my current setup is less than ideal for maintaining consistent productivity.

Specifically, I have been experiencing mild discomfort due to prolonged hours at my desk, and I believe an ergonomic chair would significantly improve my posture and focus. Additionally, a high-resolution monitor would allow me to manage my workload more effectively.

I would greatly appreciate it if you could provide more details about the application process and eligibility criteria. If possible, I'd like to submit a request for the necessary equipment at your earliest convenience.

Thank you in advance for your time and support. I look forward to your response.

Best regards,
James Whitaker`,

  translation: `제목: 원격 근무 장비 지원 요청

사라 피터슨 님께,

안녕하십니까.

최근 도입된 원격 근무 장비 지원 프로그램에 대해 문의드리고자 연락드립니다. 아시다시피, 원격 근무는 매우 유익했지만, 현재 제 작업 환경이 일관된 생산성을 유지하기에 이상적이지 않다는 점을 발견했습니다.

구체적으로, 책상에서 장시간 근무로 인해 경미한 불편함을 겪고 있으며, 인체공학적 의자가 제 자세와 집중력을 크게 개선할 것이라고 생각합니다. 또한, 고해상도 모니터가 있다면 업무량을 더 효과적으로 관리할 수 있을 것입니다.

신청 절차와 자격 기준에 대한 자세한 정보를 제공해 주시면 감사하겠습니다. 가능하다면, 가능한 빠른 시일 내에 필요한 장비에 대한 요청을 제출하고 싶습니다.

시간과 지원에 미리 감사드립니다. 답변을 기다리겠습니다.

감사합니다.
제임스 휘태커`,

  koreanNouns: `Subject: Request for Remote Work Equipment Support

Dear Sarah Peterson,

I hope you're doing well.

I am <mark>연락드립니다</mark> to inquire about the recently introduced Remote Work Equipment Support Program. As you know, working remotely has been <mark>매우</mark> beneficial, but I have found that my current setup is less than ideal for maintaining consistent productivity.

<mark>구체적으로</mark>, I have been experiencing mild discomfort due to <mark>장시간</mark> hours at my desk, and I believe an ergonomic chair would significantly improve my posture and focus. Additionally, a high-resolution monitor would allow me to manage my workload more effectively.

I would <mark>크게</mark> appreciate it if you could provide more details about the application process and <mark>자격</mark> <mark>기준</mark>. If possible, I'd like to submit a request for the necessary equipment at your <mark>가능한 빠른</mark> convenience.

Thank you in advance for your time and support. I look forward to your response.

Best regards,
James Whitaker`,

  wordPairs: {
    "reaching out": "연락드립니다",
    incredibly: "매우",
    Specifically: "구체적으로",
    prolonged: "장시간",
    greatly: "크게",
    eligibility: "자격",
    criteria: "기준",
    earliest: "가능한 빠른",
  },

  questions: [],
};
const letter29 = {
  id: 29,
  passage: `Subject: Introducing Our New Green Initiative & Energy Conservation Campaign

Dear Team,

We are excited to announce the launch of our company-wide Green Initiative and Energy Conservation Campaign. As a company committed to sustainable growth, we recognize the importance of actively reducing our carbon footprint and adopting environmentally responsible practices.

Starting next month, we will implement several effective measures to promote energy efficiency in our offices. These include:

Encouraging the use of energy-efficient devices and switching to low-power settings whenever possible.
Reducing unnecessary printing and promoting paperless communication.
Implementing strict waste management policies to improve recycling efforts.
Raising awareness through informative workshops and engaging activities.

We strongly encourage all employees to participate in this initiative by making simple yet impactful changes in their daily routines. Even small adjustments, such as turning off unused lights and unplugging idle devices, can contribute significantly to reducing overall energy consumption.

Your cooperation and dedication to this campaign will play a crucial role in making our workplace more sustainable. If you have any valuable suggestions or would like to get more actively involved, please feel free to reach out.

Together, we can create a greener, more responsible work environment!

Best regards,
Emma Collins
Sustainability Coordinator`,

  translation: `제목: 새로운 친환경 이니셔티브 및 에너지 절약 캠페인 소개

팀원 여러분께,

회사 전체 친환경 이니셔티브 및 에너지 절약 캠페인 출시를 발표하게 되어 기쁩니다. 지속 가능한 성장을 추구하는 기업으로서, 우리는 탄소 발자국을 적극적으로 줄이고 환경 책임 관행을 채택하는 것의 중요성을 인식하고 있습니다.

다음 달부터 사무실에서 에너지 효율성을 촉진하기 위한 몇 가지 효과적인 조치를 시행할 예정입니다. 이는 다음과 같습니다:

에너지 효율적인 기기 사용을 장려하고 가능한 경우 저전력 설정으로 전환하기.
불필요한 인쇄를 줄이고 종이 없는 커뮤니케이션 촉진하기.
재활용 노력을 개선하기 위한 엄격한 폐기물 관리 정책 시행하기.
유익한 워크숍과 참여 활동을 통해 인식 높이기.
모든 직원들이 일상 업무에서 간단하지만 영향력 있는 변화를 통해 이 이니셔티브에 참여하시기를 강력히 권장합니다. 사용하지 않는 조명을 끄고 유휴 기기의 플러그를 뽑는 것과 같은 작은 조정도 전체 에너지 소비를 줄이는 데 크게 기여할 수 있습니다.

이 캠페인에 대한 여러분의 협조와 헌신은 우리 직장을 더욱 지속 가능하게 만드는 데 중요한 역할을 할 것입니다. 가치 있는 제안이 있거나 더 적극적으로 참여하고 싶으시면 언제든지 연락해 주십시오.

함께라면 더 친환경적이고 책임감 있는 업무 환경을 만들 수 있습니다!

감사합니다.
에마 콜린스
지속가능성 코디네이터`,

  koreanNouns: "",

  wordPairs: {},

  questions: [],
};

const letter30 = {
  id: 30,
  passage: `Subject: Exit Interview & Feedback Request

Dear Michael Anderson,

I hope you are doing well.

As you prepare to transition from your role at BrightTech Solutions, we would like to take this opportunity to express our <mark>sincere</mark> appreciation for your valuable contributions to the company. Your dedicated efforts have had a significant impact on our team, and we truly wish you the best in your next endeavor.

To help us continuously improve our work environment and employee experience, we kindly request your honest feedback regarding your time with us. We have attached a short <mark>exit interview</mark> form, which includes questions about your overall experience, reasons for leaving, and any <mark>constructive</mark> suggestions you may have.

Your <mark>candid</mark> insights will be extremely valuable in shaping our workplace policies and ensuring a more supportive and productive environment for current and future employees.

If you are available, we would also appreciate the opportunity to schedule a brief exit interview at your earliest convenience. Please let us know a time that works best for you.

Thank you again for your hard work and dedication during your time with us. We <mark>genuinely</mark> appreciate your valuable input and wish you nothing but success moving forward.

Best regards,
Emily Carter
HR Manager
BrightTech Solutions`,

  translation: `제목: 퇴사 인터뷰 및 피드백 요청

마이클 앤더슨 님께,

안녕하십니까.

브라이트테크 솔루션즈에서의 역할을 마무리하시는 시점에, 회사에 대한 귀하의 소중한 기여에 진심으로 감사의 말씀을 전하고자 합니다. 귀하의 헌신적인 노력은 우리 팀에 중요한 영향을 미쳤으며, 앞으로의 새로운 도전에서도 최선의 결과가 있기를 진심으로 기원합니다.

업무 환경과 직원 경험을 지속적으로 개선하기 위해, 귀하의 근무 기간에 대한 솔직한 피드백을 부탁드립니다. 전반적인 경험, 퇴사 이유, 그리고 건설적인 제안 등에 관한 질문이 포함된 간단한 퇴사 인터뷰 양식을 첨부하였습니다.

귀하의 솔직한 의견은 직장 정책을 형성하고 현재와 미래의 직원들을 위한 더 지원적이고 생산적인 환경을 조성하는 데 매우 귀중한 자료가 될 것입니다.

가능하시다면, 편하신 시간에 간단한 퇴사 인터뷰를 진행할 기회를 갖고 싶습니다. 가장 적합한 시간을 알려주시기 바랍니다.

귀하의 근무 기간 동안의 열정과 헌신에 다시 한번 감사드립니다. 귀하의 소중한 의견에 진심으로 감사드리며, 앞으로의 모든 일에 성공이 함께하기를 기원합니다.

감사합니다.
에밀리 카터
인사 관리자
브라이트테크 솔루션즈`,

  koreanNouns: `Subject: Exit Interview & Feedback Request

Dear Michael Anderson,

I hope you are doing well.

As you prepare to transition from your role at BrightTech Solutions, we would like to take this opportunity to express our <mark>진심으로</mark> appreciation for your valuable contributions to the company. Your dedicated efforts have had a significant impact on our team, and we truly wish you the best in your next endeavor.

To help us continuously improve our work environment and employee experience, we kindly request your honest feedback regarding your time with us. We have attached a short <mark>퇴사 인터뷰</mark> form, which includes questions about your overall experience, reasons for leaving, and any <mark>건설적인</mark> suggestions you may have.

Your <mark>솔직한</mark> insights will be extremely valuable in shaping our workplace policies and ensuring a more supportive and productive environment for current and future employees.

If you are available, we would also appreciate the opportunity to schedule a brief exit interview at your earliest convenience. Please let us know a time that works best for you.

Thank you again for your hard work and dedication during your time with us. We <mark>진심으로</mark> appreciate your valuable input and wish you nothing but success moving forward.

Best regards,
Emily Carter
HR Manager
BrightTech Solutions`,

  wordPairs: {
    sincere: "진심으로",
    "exit interview": "퇴사 인터뷰",
    constructive: "건설적인",
    candid: "솔직한",
    genuinely: "진심으로",
  },

  questions: [],
};

const letter31 = {
  id: 31,
  passage: `Subject: Important Notice: Product Recall & Exchange Procedure

Dear Valued Customer,

At NovaTech Electronics, we are committed to delivering high-quality and <mark>reliable</mark> products. However, after conducting a <mark>thorough</mark> quality inspection, we have identified a potential <mark>defect</mark> in a specific batch of our NovaSound X200 Wireless Earbuds that may affect <mark>optimal</mark> performance.

To ensure the safety and satisfaction of our customers, we are <mark>initiating</mark> a voluntary recall of this product. If you have purchased a unit with the serial numbers NSX200-20240301 to NSX200-20240415, we kindly ask you to follow the simple exchange process outlined below:

- Confirm Your Eligibility: Check your product's serial number on the original packaging or device settings.
- Request a Replacement: Visit our official recall page [link] and complete the exchange request form.
- Return the Affected Product: We will provide a prepaid shipping label for you to send back the recalled unit at no additional cost.
- Receive a New Unit: Once we receive your return, a brand-new replacement unit will be shipped to you immediately.

We sincerely apologize for any inconvenience this may cause and appreciate your prompt cooperation. Ensuring the highest product standards remains our top priority, and we are working <mark>diligently</mark> to resolve this issue as efficiently as possible.

If you have any questions or require further assistance, please do not hesitate to contact our dedicated customer support team at support@novatechelectronics.com.

Thank you for your trust and loyalty.

Best regards,
Olivia Reynolds
Customer Support Manager
NovaTech Electronics`,

  translation: `제목: 중요 공지: 제품 리콜 및 교환 절차

고객님께,

노바테크 일렉트로닉스는 고품질의 신뢰할 수 있는 제품을 제공하기 위해 최선을 다하고 있습니다. 그러나 철저한 품질 검사를 실시한 결과, 노바사운드 X200 무선 이어버드의 특정 배치에서 최적의 성능에 영향을 미칠 수 있는 잠재적 결함을 발견했습니다.

고객의 안전과 만족을 보장하기 위해 이 제품에 대한 자발적 리콜을 시작합니다. 시리얼 번호 NSX200-20240301부터 NSX200-20240415까지의 제품을 구매하신 경우, 아래에 설명된 간단한 교환 절차를 따라주시기 바랍니다:

자격 확인: 원래 포장이나 기기 설정에서 제품의 시리얼 번호를 확인하세요.
교체 요청: 공식 리콜 페이지 [링크]를 방문하여 교환 요청 양식을 작성하세요.
영향받은 제품 반품: 추가 비용 없이 리콜된 제품을 반송할 수 있는 선불 배송 라벨을 제공해 드립니다.
새 제품 수령: 반품을 받는 즉시 새로운 교체 제품을 즉시 발송해 드립니다.
이로 인해 발생할 수 있는 불편에 진심으로 사과드리며 신속한 협조에 감사드립니다. 최고의 제품 표준을 보장하는 것이 저희의 최우선 과제이며, 이 문제를 가능한 효율적으로 해결하기 위해 성실히 노력하고 있습니다.

질문이 있거나 추가 도움이 필요하시면 언제든지 support@novatechelectronics.com으로 전담 고객 지원팀에 문의해 주십시오.

귀하의 신뢰와 충성에 감사드립니다.

감사합니다.
올리비아 레이놀즈
고객 지원 관리자
노바테크 일렉트로닉스`,

  koreanNouns: `Subject: Important Notice: Product Recall & Exchange Procedure

Dear Valued Customer,

At NovaTech Electronics, we are committed to delivering high-quality and <mark>신뢰할 수 있는</mark> products. However, after conducting a <mark>철저한</mark> quality inspection, we have identified a potential <mark>결함</mark> in a specific batch of our NovaSound X200 Wireless Earbuds that may affect <mark>최적의</mark> performance.

To ensure the safety and satisfaction of our customers, we are <mark>시작합니다</mark> a voluntary recall of this product. If you have purchased a unit with the serial numbers NSX200-20240301 to NSX200-20240415, we kindly ask you to follow the simple exchange process outlined below:

- Confirm Your Eligibility: Check your product's serial number on the original packaging or device settings.
- Request a Replacement: Visit our official recall page [link] and complete the exchange request form.
- Return the Affected Product: We will provide a prepaid shipping label for you to send back the recalled unit at no additional cost.
- Receive a New Unit: Once we receive your return, a brand-new replacement unit will be shipped to you immediately.

We sincerely apologize for any inconvenience this may cause and appreciate your prompt cooperation. Ensuring the highest product standards remains our top priority, and we are working <mark>성실히</mark> to resolve this issue as efficiently as possible.

If you have any questions or require further assistance, please do not hesitate to contact our dedicated customer support team at support@novatechelectronics.com.

Thank you for your trust and loyalty.

Best regards,
Olivia Reynolds
Customer Support Manager
NovaTech Electronics`,

  wordPairs: {
    reliable: "신뢰할 수 있는",
    thorough: "철저한",
    defect: "결함",
    optimal: "최적의",
    initiating: "시작합니다",
    diligently: "성실히",
  },

  questions: [],
};

const letter32 = {
  id: 32,
  passage: `Subject: Urgent: Contract Signing & Official Document Submission

Dear Jonathan Parker,

I hope you are doing well.

As part of the finalization process for our agreement, we kindly request the prompt completion of the attached contract. To ensure a smooth and efficient transition, please review the document carefully and provide your official signature by March 22.

Additionally, we require the following essential documents to be submitted along with the signed contract:

Valid identification (passport or driver's license)
Company registration certificate (if applicable)
Recent financial statement (for verification purposes)
For your convenience, all documents can be uploaded via our secure online portal [link] or sent via email to legal@harborconsulting.com. If you need any further clarification or require additional time, please inform us at your earliest convenience.

We appreciate your cooperation and timely response, as these documents are crucial for the successful execution of our agreement.

Thank you for your attention to this matter. We look forward to receiving the signed contract and required documents soon.

Best regards,
Sophia Mitchell
Legal Affairs Coordinator
Harbor Consulting Group`,

  translation: `제목: 긴급: 계약서 서명 및 공식 문서 제출

조나단 파커님께,

안녕하세요.

저희 계약 최종 처리 과정의 일환으로, 첨부된 계약서의 신속한 작성을 요청드립니다. 원활하고 효율적인 진행을 위해, 문서를 주의 깊게 검토하시고 3월 22일까지 공식 서명을 제공해 주시기 바랍니다.

또한, 서명된 계약서와 함께 다음과 같은 필수 문서를 제출해 주셔야 합니다:

유효한 신분증(여권 또는 운전면허증)
회사 등록증(해당되는 경우)
최근 재무제표(확인 목적)
편의를 위해 모든 문서는 저희 보안 온라인 포털 [링크]을 통해 업로드하거나 legal@harborconsulting.com으로 이메일을 통해 보내실 수 있습니다. 추가 설명이 필요하시거나 시간이 더 필요하신 경우, 가능한 빨리 알려주시기 바랍니다.

이 문서들은 저희 계약의 성공적인 실행을 위해 매우 중요하므로, 귀하의 협조와 신속한 응답에 감사드립니다.

이 사안에 대한 관심에 감사드립니다. 서명된 계약서와 필요한 문서를 곧 받기를 기대합니다.

감사합니다.
소피아 미첼
법무 조정관
하버 컨설팅 그룹`,

  koreanNouns: "",

  wordPairs: {},

  questions: [],
};

const letter33 = {
  id: 33,
  passage: `Subject: Request for a Letter of Recommendation

Dear Mark Reynolds,

I hope you are doing well.

I am reaching out to kindly request a formal letter of recommendation as I transition to my next career opportunity. During my time at Sterling Innovations, I had the <mark>privilege</mark> of working under your expert guidance, and I truly appreciate the <mark>valuable</mark> experience I gained as part of your team.

As I pursue a new role in project management, a strong and <mark>credible</mark> reference from you would be highly beneficial in demonstrating my professional skills, dedication, and ability to collaborate effectively. If possible, I would greatly appreciate a detailed letter highlighting my key contributions, work ethic, and any <mark>notable</mark> achievements during my tenure.

I understand your busy schedule, so I would be happy to provide any necessary details or a draft to assist you. If you are comfortable with this request, please let me know at your earliest convenience.

Thank you for your time and consideration. Your support would mean a great deal to me, and I sincerely appreciate your kind assistance.

Best regards,
Daniel Carter
Former Project Coordinator
Sterling Innovations`,

  translation: `제목: 추천서 요청

마크 레이놀즈님께,

안녕하세요.

다음 경력 기회로 전환하면서 공식 추천서를 요청드리고자 연락드립니다. 스털링 이노베이션에서 근무하는 동안 귀하의 전문적인 지도 아래 일할 수 있는 특권을 가졌으며, 귀하의 팀의 일원으로서 얻은 귀중한 경험에 진심으로 감사드립니다.

프로젝트 관리 분야의 새로운 역할을 추구하면서, 귀하의 강력하고 신뢰할 수 있는 추천서는 제 전문적인 기술, 헌신, 효과적인 협업 능력을 입증하는 데 매우 유익할 것입니다. 가능하다면, 제 주요 기여, 직업 윤리, 그리고 재직 기간 동안의 주목할 만한 성과를 강조하는 상세한 추천서를 작성해 주시면 대단히 감사하겠습니다.

귀하의 바쁜 일정을 이해하고 있으므로, 필요한 세부 정보나 초안을 제공하여 도움을 드릴 수 있습니다. 이 요청에 동의하신다면, 가능한 빨리 알려주시기 바랍니다.

시간과 고려에 감사드립니다. 귀하의 지원은 저에게 큰 의미가 있으며, 귀하의 친절한 도움에 진심으로 감사드립니다.

감사합니다.
다니엘 카터
전 프로젝트 코디네이터
스털링 이노베이션`,
  koreanNouns: `Subject: Request for a Letter of Recommendation

Dear Mark Reynolds,

I hope you are doing well.

I am reaching out to kindly request a formal letter of recommendation as I transition to my next career opportunity. During my time at Sterling Innovations, I had the <mark>특권</mark> of working under your expert guidance, and I truly appreciate the <mark>귀중한</mark> experience I gained as part of your team.

As I pursue a new role in project management, a strong and <mark>신뢰할 수 있는</mark> reference from you would be highly beneficial in demonstrating my professional skills, dedication, and ability to collaborate effectively. If possible, I would greatly appreciate a detailed letter highlighting my key contributions, work ethic, and any <mark>주목할 만한</mark> achievements during my tenure.

I understand your busy schedule, so I would be happy to provide any necessary details or a draft to assist you. If you are comfortable with this request, please let me know at your earliest convenience.

Thank you for your time and consideration. Your support would mean a great deal to me, and I sincerely appreciate your kind assistance.

Best regards,
Daniel Carter
Former Project Coordinator
Sterling Innovations`,

  wordPairs: {
    privilege: "특권",
    valuable: "귀중한",
    credible: "신뢰할 수 있는",
    notable: "주목할 만한",
  },

  questions: [],
};

export const letterQuestions = [
  letter3,
  letter4,
  letter5,
  letter6,
  letter7,
  letter8,
  letter9,
  letter10,
  letter11,
  letter12,
  letter13,
  letter14,
  letter15,
  letter16,
  letter17,
  letter18,
  letter19,
  letter20,
  letter21,
  letter22,
  letter23,
  letter24,
  letter25,
  letter26,
  letter27,
  letter28,
  letter29,
  letter30,
  letter31,
  letter32,
  letter33,
];
